<template>
  <div>
    <div v-if="isLoading" class="loading text-center h-100 d-flex align-items-center justify-content-center">
      <img src="/img/loading.gif" width="48" height="48" alt="Loading New ID" />
    </div>
    <div v-else>
      <div class="row mt-2 mb-3">
        <!-- QR Registration Title -->
        <div class="col-md-6 col-12">
          <h4 class="mb-0">
            QR Registration
            <div class="tooltip-container">
              <span><i class="fas fa-info-circle"></i></span>
              <div class="tooltip">
                <div v-if="!showPerformanceYear" class="tooltip-content">Data yang ditampilkan adalah berdasarkan
                  Production Year</div>
                <div v-if="showPerformanceYear" class="tooltip-content">Data yang ditampilkan adalah berdasarkan
                  Performance Year</div>
              </div>
            </div>
          </h4>
        </div>

        <!-- Toggle Switch -->
        <div class="col-md-2 ml-auto d-flex align-items-center toggle-switch-container">
          <p class="mr-2 mb-0">Show Performance Year</p>
          <label class="switch">
            <toggle-button :width="50" :height="30" color="#134F97" v-model="showPerformanceYear"
              @change="onToggleChange" />
          </label>
        </div>

        <div class="col-md-12">
          <div class="row">
            <!-- Registration Type Buttons -->
            <div class="col-md-1 p-0">
              <button type="button" class="w-100 btn" :style="{
                'background-color': registrationType === 'New ID' ? '#134F97' : 'white',
                color: registrationType === 'New ID' ? 'white' : '#134F97',
                border: '1px solid #134F97',
                'border-radius': '6px 0 0 6px',
              }" @click="switchRegistrationType('New ID')">
                New ID
              </button>
            </div>
            <div class="col-md-1 p-0">
              <button type="button" class="w-100 btn" :style="{
                'background-color': registrationType === 'Existing ID' ? '#134F97' : 'white',
                color: registrationType === 'Existing ID' ? 'white' : '#134F97',
                border: '1px solid #134F97',
                'border-radius': '0 6px 6px 0',
              }" @click="switchRegistrationType('Existing ID')">
                Existing
              </button>
            </div>

            <!-- Spacing -->
            <div class="col-12 col-md-auto mt-2 ml-auto mt-md-0"></div>

            <!-- Date Picker -->
            <div :class="['col-12 mt-2 mt-md-0', { 'ml-auto': showPerformanceYear }]"
              :style="{ flex: '0 0 20%', maxWidth: '20%' }">
              <div class="filter-date icon fa-calendar">
                <flat-pickr v-model="dateRange.date" :config="rangeConfig" class="form-control w-100"
                  :placeholder="todayPlaceholder" />
              </div>
            </div>
            <!-- Year Select -->
            <div v-if="!showPerformanceYear" class="col-12 col-md-2 mt-2 mt-md-0">
              <Multiselect v-model="selectedYearGlobal" :options="optionYears" :placeholder="yearPlaceholder"
                @input="selectGlobalYear" />
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-4" v-if="registrationType === 'New ID'">
        <div class="col-md-8">
          <div class="card d-flex flex-column relative" :class="{
            '': registrationType != 'New ID',
            'new-id-production-year': registrationType == 'New ID',
          }">
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <h5 class="card-title mb-0 mr-2">{{ registrationType }}</h5>
                <div class="tooltip-container">
                  <span><i class="fas fa-info-circle"></i></span>
                  <div class="tooltip">
                    <div class="tooltip-content">Kendaraan yang pertama kali melakukan servis di H2</div>
                  </div>
                </div>
                <div class="d-flex ml-auto">
                  <Multiselect v-model="selectedChartStacked" class="mt-1" :options="optionChartStacked"
                    track-by="loc_code" label="label" placeholder="All Dealers" style="width: 150px"></Multiselect>
                  <button
                    class="replacement-download btn btn-outline-secondary ml-2 d-flex align-items-center justify-content-center"
                    @click="downloadExcelChartStacked()" style="width: 200px">
                    Download CSV
                    <i class="ml-2 fa-solid fa-file-arrow-down"></i>
                  </button>
                </div>
              </div>
              <div v-if="isLoadingChartStacked"
                class="loading text-center h-100 d-flex align-items-center justify-content-center">
                <img src="/img/loading.gif" width="48" height="48" alt="Loading New ID" />
              </div>
              <new-id-chart-stacked-column v-else="dataChartStacked" :start-date="dateRange.start"
                :end-date="dateRange.end" :selected-year-global="selectedYearGlobal"
                :selected-chart-dealer="selectedChartStacked" :chart-data="dataChartStacked" />
            </div>
          </div>
        </div>

        <div class="col-md-4" v-if="registrationType === 'New ID'">
          <div class="card d-flex flex-column relative" :class="{
            '': registrationType != 'New ID',
            'new-id-production-year': registrationType == 'New ID',
          }">
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <h6 class="card-title mb-0 mr-2">
                  <span v-if="!showPerformanceYear">Overall by Production Year</span>
                  <span v-else>Performance by Year</span>
                  <div class="tooltip-container">
                    <span><i class="fas fa-info-circle"></i></span>
                    <div class="tooltip">
                      <!-- Conditional Rendering untuk Tooltip -->
                      <div class="tooltip-content" v-if="!showPerformanceYear">Presentase data new ID berdasarkan tahun
                        produksi</div>
                      <div class="tooltip-content" v-else>Presentase data new ID berdasarkan tahun</div>
                    </div>
                  </div>
                </h6>
                <div class="d-flex ml-auto">
                  <button
                    class="replacement-download btn btn-outline-secondary ml-2 d-flex align-items-center justify-content-center"
                    @click="downloadExcelOverallProductionYear()" style="width: 200px">
                    Download CSV
                    <i class="ml-2 fa-solid fa-file-arrow-down"></i>
                  </button>
                </div>
              </div>
              <div v-if="isLoadingOverallProductionYear"
                class="loading text-center h-100 d-flex align-items-center justify-content-center">
                <img src="/img/loading.gif" width="48" height="48" alt="Loading New ID" />
              </div>
              <new-id-chart-overall-production-year v-else="dataChartOverallProductionYear"
                :start-date="dateRange.start" :end-date="dateRange.end" :selected-year-global="selectedYearGlobal"
                :chart-data="dataChartOverallProductionYear" />
            </div>
          </div>
        </div>
      </div>

      <div v-if="registrationType === 'New ID' && showPerformanceYear" class="card mb-4 relative">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <h5 class="card-title mb-0 mr-2">Perfomance Comparison</h5>
            <div class="tooltip-container">
              <span><i class="fas fa-info-circle"></i></span>
              <div class="tooltip">
                <div class="tooltip-content">Perbandingan antar tahun data kendaraan yang melakukan pergantian QR di H2
                </div>
              </div>
            </div>
            <div class="d-flex ml-auto align-items-center">
              <!-- First Range Picker -->
              <div style="position: relative;">
                <div class="filter-date icon fa-calendar mr-3" style="width: 200px">
                  <flat-pickr v-model="firstRange" :config="monthYearConfig" class="form-control w-100"
                    placeholder="Select First Range" @on-change="updateFirstRange" />
                </div>
                <div v-if="secondRange && !firstRange"
                  style="position: absolute; top: 100%; left: 0; color: blue; font-size: 12px;">
                  Select the first date!
                </div>
              </div>

              <h5 class="mr-3 mb-0">and</h5>

              <!-- Second Range Picker -->
              <div style="position: relative;">
                <div class="filter-date icon fa-calendar mr-3" style="width: 200px">
                  <flat-pickr v-model="secondRange" :config="monthYearConfig" class="form-control w-100"
                    placeholder="Select Second Range" @on-change="updateSecondRange" />
                </div>
                <div v-if="firstRange && !secondRange"
                  style="position: absolute; top: 100%; left: 0; color: blue; font-size: 12px;">
                  Select the second date!
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center ml-auto">
              <Multiselect v-model="selectedComparisonRegion" class="mt-1" :options="optionComparisonRegion"
                track-by="loc_code" label="name" placeholder="Region" style="width: 200px; height: 40px;">
              </Multiselect>
              <button
                class="replacement-download btn btn-outline-secondary ml-2 d-flex align-items-center justify-content-center"
                @click="downloadComparison()" style="width: 200px">
                Download CSV
                <i class="ml-2 fa-solid fa-file-arrow-down"></i>
              </button>
            </div>
          </div>
          <div v-if="isLoadingChartStacked"
            class="loading text-center h-100 d-flex align-items-center justify-content-center">
            <img src="/img/loading.gif" width="48" height="48" alt="Loading New ID" />
          </div>
          <new-id-chart-perfomance-comparison ref="performanceChart" v-if="showPerformanceYear"
            :first-range="formattedFirstRange" :second-range="formattedSecondRange"
            :region="selectedComparisonRegion ? selectedComparisonRegion.loc_code : ''" />
        </div>
      </div>

      <div class="card mb-4 relative" v-if="registrationType === 'New ID'">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <h5 class="card-title mb-0 mr-2">Segment</h5>
            <div class="tooltip-container">
              <span><i class="fas fa-info-circle"></i></span>
              <div class="tooltip">
                <div class="tooltip-title">Segment</div>
                <div class="tooltip-content">Kendaraan yang pertama kali melakukan servis di H2 dilihat berdasarkan
                  segmentasi motor</div>
              </div>
            </div>
            <div class="d-flex ml-auto">
              <Multiselect class="mt-1 ml-2" v-model="selectedSegment" :options="optionSegments" :multiple="true"
                placeholder="Select Segments" style="width: 200px"></Multiselect>
              <Multiselect class="mt-1 ml-2" v-model="selectedYearSegment"
                :options="optionYears.filter(y => y !== 'Unknown' || !showPerformanceYear)" placeholder="All Years"
                style="width: 200px"></Multiselect>
              <button
                class="replacement-download btn btn-outline-secondary ml-2 d-flex align-items-center justify-content-center"
                @click="downloadExcelSegment()" style="width: 200px;">
                Download CSV
                <i class="ml-2 fa-solid fa-file-arrow-down"></i>
              </button>
            </div>
          </div>
          <div v-if="isLoadingSegment"
            class="loading text-center h-100 d-flex align-items-center justify-content-center">
            <img src="/img/loading.gif" width="48" height="48" alt="Loading New ID" />
          </div>
          <new-id-chart-segment v-else="dataSegment" :start-date="dateRange.start" :end-date="dateRange.end"
            :selected-year="selectedYearGlobal" :selected-year-segment="selectedYearSegment"
            :selected-segments="selectedSegment" :chart-data="dataSegment" />
        </div>
      </div>

      <div class="card mb-4 relative card-table" v-if="registrationType === 'New ID'">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <h5 class="card-title mb-0 mr-2">{{ registrationType }} by Region</h5>
            <div class="tooltip-container">
              <span><i class="fas fa-info-circle"></i></span>
              <div class="tooltip">
                <div class="tooltip-content">Kendaraan yang pertama kali melakukan servis di H2 berdasarkan lokasi
                  region</div>
              </div>
            </div>
            <div class="d-flex ml-auto">
              <Multiselect v-model="selectedRegion" :options="optionRegions" placeholder="Semua MD" class="mt-1 ml-2"
                style="width: 200px"></Multiselect>
              <Multiselect v-model="selectedYearRegion"
                :options="optionYears.filter(y => y !== 'Unknown' || !showPerformanceYear)" placeholder="All Years"
                class="mt-1 ml-2" style="width: 200px"></Multiselect>

              <button
                class="replacement-download btn btn-outline-secondary ml-2 d-flex align-items-center justify-content-center"
                @click="downloadExcelRegion()" style="width: 200px">
                Download CSV
                <i class="ml-2 fa-solid fa-file-arrow-down"></i>
              </button>
            </div>
          </div>
          <div v-if="isLoadingRegion"
            class="loading text-center h-100 d-flex align-items-center justify-content-center">
            <img src="/img/loading.gif" width="48" height="48" :alt="`Loading ${registrationType} Region`" />
          </div>
          <div v-else>
            <table class="table table-hover">
              <thead>
                <tr>
                  <th class="hso-table-header" style="background-color: #ffffff">Region Name</th>
                  <th v-for="month in displayedMonths" :key="month" class="hso-table-header"
                    style="background-color: #ffffff">
                    {{ month }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="Object.keys(dataRegion).length === 0">
                  <td colspan="100%" style="padding: 2rem 0">
                    <p style="font-weight: bold; font-size: 1.5rem; line-height: 1">No Data Available.</p>
                    <p style="margin-top: -0.5rem">Please choose another time or option</p>
                  </td>
                </tr>
                <tr v-else v-for="(regionData, regionName) in paginatedData" :key="regionName">
                  <td class="hso-table-body" style="border-bottom: none; border-top: none">{{ regionName }}</td>
                  <td v-for="month in displayedMonths" :key="month" class="hso-table-body"
                    style="border-bottom: none; border-top: none">
                    {{ getValueForMonth(regionData, month) }}
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- New ID Region Pagination -->
            <div class="d-flex justify-content-between align-items-center mt-3">
              <div>Showing {{ paginationStart + 1 }} to {{ paginationEnd }} of {{ totalItems }} entries</div>
              <b-pagination v-model="currentPage" :total-rows="totalItems" :per-page="rowsPerPage"
                aria-controls="replacement-table"></b-pagination>
            </div>
          </div>
        </div>
      </div>

      <b-card class="mb-4 relative card-table" v-if="registrationType === 'New ID'">
        <div class="d-flex align-items-center mb-3">
          <h5 class="card-title mb-0 mr-2">{{ registrationType }} by Dealer</h5>
          <div class="tooltip-container">
            <span><i class="fas fa-info-circle"></i></span>
            <div class="tooltip">
              <div class="tooltip-content">Kendaraan yang pertama kali melakukan servis di H2 berdasarkan lokasi dealer
              </div>
            </div>
          </div>
          <div class="d-flex ml-auto">
            <Multiselect v-model="selectedDealer" class="mt-1 ml-2" :options="optionDealers" placeholder="All Dealer"
              style="width: 200px"></Multiselect>
            <Multiselect v-model="selectedYearDealer" class="mt-1 ml-2"
              :options="optionYears.filter(y => y !== 'Unknown' || !showPerformanceYear)" placeholder="All Years"
              style="width: 200px" @change="selectedYearDealer"></Multiselect>
            <button
              class="replacement-download btn btn-outline-secondary ml-2 d-flex align-items-center justify-content-center"
              @click="downloadExcelDealer()" style="width: 200px;">
              Download CSV
              <i class="ml-2 fa-solid fa-file-arrow-down"></i>
            </button>
          </div>
        </div>
        <div v-if="isLoadingDealer" class="loading text-center h-100 d-flex align-items-center justify-content-center">
          <img src="/img/loading.gif" width="48" height="48" :alt="`Loading ${registrationType} Dealer`" />
        </div>
        <div v-else>
          <table class="table">
            <thead>
              <tr>
                <th class="hso-table-header" style="background-color: #ffffff">Dealer Name</th>
                <th v-for="(year, index) in optionYears.filter(y => y !== 'Unknown' || !showPerformanceYear)"
                  :key="index"
                  v-if="!selectedYearDealer || selectedYearDealer === 'All Years' || selectedYearDealer === year"
                  class="hso-table-header" style="background-color: #ffffff">
                  {{ year }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="dataDealer.length === 0">
                <td colspan="100%" style="padding: 2rem 0">
                  <p style="font-weight: bold; font-size: 1.5rem; line-height: 1">No Data Available.</p>
                  <p style="margin-top: -0.5rem">Please choose another time or option</p>
                </td>
              </tr>
              <tr v-else v-for="(dealerData, dealerName) in dealerPaginatedData" :key="dealerName">
                <td class="hso-table-body" style="border-bottom: none; border-top: none">{{ dealerName }}</td>
                <td v-for="(year, index) in optionYears.filter(y => y !== 'Unknown' || !showPerformanceYear)"
                  :key="index"
                  v-if="!selectedYearDealer || selectedYearDealer === 'All Years' || selectedYearDealer === year"
                  class="hso-table-body" style="border-bottom: none; border-top: none">
                  <template v-if="year === optionYears[optionYears.length - 2]"> {{
                    getDealerValueForOlderYears(dealerData, parseInt(year.replace("<=", ""))) }} </template>
                      <template v-else>
                        {{ getDealerValueForYear(dealerData, year) }}
                      </template>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- New ID Dealer Pagination -->
          <div class="d-flex justify-content-between align-items-center mt-3">
            <div class="hso-table-pagination">Showing {{ dealerPaginationStart + 1 }} to {{ dealerPaginationEnd }} of {{
              filteredDealerTotalItems }} entries</div>
            <b-pagination v-model="dealerCurrentPage" :total-rows="filteredDealerTotalItems"
              :per-page="dealerRowsPerPage" aria-controls="dealer-table"></b-pagination>
          </div>
        </div>
      </b-card>

      <!-- Existing ID Start -->
      <div class="row mb-4" v-if="registrationType === 'Existing ID'">
        <div class="col-md-8">
          <div class="card d-flex flex-column relative" :class="{
            '': registrationType != 'Existing ID',
            'new-id-production-year': registrationType == 'Existing ID',
          }">
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <h5 class="card-title mb-0 mr-2">{{ registrationType }}</h5>
                <div class="tooltip-container">
                  <span><i class="fas fa-info-circle"></i></span>
                  <div class="tooltip">
                    <div class="tooltip-content">Kendaraan yang pertama kali melakukan servis di H2</div>
                  </div>
                </div>
                <div class="d-flex ml-auto">
                  <div class="d-flex ml-auto">
                    <Multiselect v-model="selectedChartStacked" class="mt-1" :options="optionChartStacked"
                      track-by="loc_code" label="label" placeholder="All Dealers" style="width: 150px"></Multiselect>
                    <button
                      class="replacement-download btn btn-outline-secondary ml-2 d-flex align-items-center justify-content-center"
                      @click="downloadExcelChartStacked()" style="width: 200px;">
                      Download CSV
                      <i class="ml-2 fa-solid fa-file-arrow-down"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="isLoadingChartStacked"
                class="loading text-center h-100 d-flex align-items-center justify-content-center">
                <img src="/img/loading.gif" width="48" height="48" alt="Loading New ID" />
              </div>
              <existing-id-chart-stacked-column v-else="dataChartStacked" :start-date="dateRange.start"
                :end-date="dateRange.end" :selected-year-global="selectedYearGlobal"
                :selected-chart-dealer="selectedChartStacked" :chart-data="dataChartStacked" />

              <!-- Pass Existing ID -->
            </div>
          </div>
        </div>

        <div class="col-md-4" v-if="registrationType === 'Existing ID'">
          <div class="card d-flex flex-column relative" :class="{
            '': registrationType != 'Existing ID',
            'new-id-production-year': registrationType == 'Existing ID',
          }">
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <h6 class="card-title mb-0 mr-2">
                  <span v-if="!showPerformanceYear">Overall by Production Year</span>
                  <span v-else>Performance by Year</span>
                  <div class="tooltip-container">
                    <span><i class="fas fa-info-circle"></i></span>
                    <div class="tooltip">
                      <!-- Conditional Rendering untuk Tooltip -->
                      <div class="tooltip-content" v-if="!showPerformanceYear">Presentase data Existing ID berdasarkan
                        tahun
                        produksi</div>
                      <div class="tooltip-content" v-else>Presentase data Existing ID berdasarkan tahun</div>
                    </div>
                  </div>
                </h6>
                <div class="d-flex ml-auto">
                  <button
                    class="replacement-download btn btn-outline-secondary ml-2 d-flex align-items-center justify-content-center"
                    @click="downloadExcelOverallProductionYear()" style="width: 200px">
                    Download CSV
                    <i class="ml-2 fa-solid fa-file-arrow-down"></i>
                  </button>
                </div>
              </div>
              <div v-if="isLoadingOverallProductionYear"
                class="loading text-center h-100 d-flex align-items-center justify-content-center">
                <img src="/img/loading.gif" width="48" height="48" alt="Loading New ID" />
              </div>
              <existing-id-chart-overall-production-year v-else="dataChartOverallProductionYear"
                :start-date="dateRange.start" :end-date="dateRange.end" :selected-year-global="selectedYearGlobal"
                :chart-data="dataChartOverallProductionYear" />
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-4 relative" v-if="registrationType === 'Existing ID' && showPerformanceYear">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <h5 class="card-title mb-0 mr-2">Perfomance Comparison</h5>
            <div class="tooltip-container">
              <span><i class="fas fa-info-circle"></i></span>
              <div class="tooltip">
                <div class="tooltip-content">Perbandingan antar tahun data kendaraan yang melakukan pergantian QR di H2
                </div>
              </div>
            </div>
            <div class="d-flex ml-auto align-items-center">
              <!-- First Range Picker -->
              <div style="position: relative;">
                <div class="filter-date icon fa-calendar mr-3" style="width: 200px">
                  <flat-pickr v-model="firstRange" :config="monthYearConfig" class="form-control w-100"
                    placeholder="Select First Range" @on-change="updateFirstRange" />
                </div>
                <div v-if="secondRange && !firstRange"
                  style="position: absolute; top: 100%; left: 0; color: blue; font-size: 12px;">
                  Select the second date!
                </div>
              </div>
              <h5 class="mr-3 mb-0">and</h5>
              <!-- Second Range Picker -->
              <div style="position: relative;">
                <div class="filter-date icon fa-calendar mr-3" style="width: 200px">
                  <flat-pickr v-model="secondRange" :config="monthYearConfig" class="form-control w-100"
                    placeholder="Select Second Range" @on-change="updateSecondRange" />
                </div>
                <div v-if="firstRange && !secondRange"
                  style="position: absolute; top: 100%; left: 0; color: blue; font-size: 12px;">
                  Select the second date!
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center ml-auto">
              <Multiselect v-model="selectedComparisonRegion" class="mt-1" :options="optionComparisonRegion"
                track-by="loc_code" label="name" placeholder="Region" style="width: 200px; height: 40px;">
              </Multiselect>
              <button
                class="replacement-download btn btn-outline-secondary ml-2 d-flex align-items-center justify-content-center"
                @click="downloadComparison()" style="width: 200px">
                Download CSV
                <i class="ml-2 fa-solid fa-file-arrow-down"></i>
              </button>
            </div>
          </div>
          <div v-if="isLoadingChartStacked"
            class="loading text-center h-100 d-flex align-items-center justify-content-center">
            <img src="/img/loading.gif" width="48" height="48" alt="Loading New ID" />
          </div>
          <existing-id-chart-perfomance-comparison :first-range="formattedFirstRange"
            :second-range="formattedSecondRange"
            :region="selectedComparisonRegion ? selectedComparisonRegion.loc_code : ''" />
        </div>
      </div>
      <!-- Tabel Existing Segment -->
      <div class="card mb-4 relative" v-if="registrationType === 'Existing ID'">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <h5 class="card-title mb-0 mr-2">Segment</h5>
            <div class="tooltip-container">
              <span><i class="fas fa-info-circle"></i></span>
              <div class="tooltip">
                <div class="tooltip-title">Segment</div>
                <div class="tooltip-content">Kendaraan yang pertama kali melakukan servis di H2 dilihat berdasarkan
                  segmentasi
                  motor</div>
              </div>
            </div>
            <div class="d-flex ml-auto">
              <Multiselect class="mt-1 ml-2" v-model="selectedSegment" :options="optionSegments" :multiple="true"
                placeholder="Select Segments" style="width: 200px"></Multiselect>
              <Multiselect class="mt-1 ml-2" v-model="selectedYearSegment"
                :options="optionYears.filter(y => y !== 'Unknown' || !showPerformanceYear)" placeholder="All Years"
                style="width: 200px"></Multiselect>
              <button
                class="replacement-download btn btn-outline-secondary ml-2 d-flex align-items-center justify-content-center"
                @click="downloadExcelSegment()" style="width: 200px">
                Download CSV
                <i class="ml-2 fa-solid fa-file-arrow-down"></i>
              </button>
            </div>
          </div>
          <div v-if="isLoadingSegment"
            class="loading text-center h-100 d-flex align-items-center justify-content-center">
            <img src="/img/loading.gif" width="48" height="48" alt="Loading New ID" />
          </div>
          <existing-id-chart-segment v-else="dataSegment" ref="segmentChart" :start-date="dateRange.start"
            :end-date="dateRange.end" :selected-year-segment="selectedYearSegment" :selected-segments="selectedSegment"
            :chart-data="dataSegment" />
        </div>
      </div>
      <!-- Tabel Existing Region -->
      <div class="card mb-4 relative card-table" v-if="registrationType === 'Existing ID'">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <h5 class="card-title mb-0 mr-2">{{ registrationType }} by Region</h5>
            <div class="tooltip-container">
              <span><i class="fas fa-info-circle"></i></span>
              <div class="tooltip">
                <div class="tooltip-content">Kendaraan yang pertama kali melakukan servis di H2 berdasarkan lokasi
                  region
                </div>
              </div>
            </div>
            <div class="d-flex ml-auto">
              <Multiselect v-model="selectedRegion" :options="optionRegions" placeholder="Semua MD" class="mt-1 ml-2"
                style="width: 200px"></Multiselect>
              <Multiselect v-model="selectedYearRegion"
                :options="optionYears.filter(y => y !== 'Unknown' || !showPerformanceYear)" placeholder="All Years"
                class="mt-1 ml-2" style="width: 200px"></Multiselect>
              <button
                class="replacement-download btn btn-outline-secondary ml-2 d-flex align-items-center justify-content-center"
                @click="downloadExcelRegion()" style="width: 200px">
                Download CSV
                <i class="ml-2 fa-solid fa-file-arrow-down"></i>
              </button>
            </div>
          </div>
          <div v-if="isLoadingRegion"
            class="loading text-center h-100 d-flex align-items-center justify-content-center">
            <img src="/img/loading.gif" width="48" height="48" :alt="`Loading ${registrationType} Region`" />
          </div>
          <div v-else>
            <table class="table table-hover">
              <thead>
                <tr>
                  <th class="hso-table-header" style="background-color: #ffffff">Region Name</th>
                  <th v-for="month in displayedMonths" :key="month" class="hso-table-header"
                    style="background-color: #ffffff">
                    {{ month }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="Object.keys(dataRegion).length === 0">
                  <td colspan="100%" style="padding: 2rem 0">
                    <p style="font-weight: bold; font-size: 1.5rem; line-height: 1">No Data Available.</p>
                    <p style="margin-top: -0.5rem">Please choose another time or option</p>
                  </td>
                </tr>
                <tr v-else v-for="(regionData, regionName) in paginatedData" :key="regionName">
                  <td class="hso-table-body" style="border-bottom: none; border-top: none">{{ regionName }}</td>
                  <td v-for="month in displayedMonths" :key="month" class="hso-table-body"
                    style="border-bottom: none; border-top: none">
                    {{ getValueForMonth(regionData, month) }}
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- New ID Region Pagination -->
            <div class="d-flex justify-content-between align-items-center mt-3">
              <div>Showing {{ paginationStart + 1 }} to {{ paginationEnd }} of {{ totalItems }} entries</div>
              <b-pagination v-model="currentPage" :total-rows="totalItems" :per-page="rowsPerPage"
                aria-controls="replacement-table"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- Tabel Dealer Existing -->
      <b-card class="mb-4 relative card-table" v-if="registrationType === 'Existing ID'">
        <div class="d-flex align-items-center mb-3">
          <h5 class="card-title mb-0 mr-2">{{ registrationType }} by Dealer</h5>
          <div class="tooltip-container">
            <span><i class="fas fa-info-circle"></i></span>
            <div class="tooltip">
              <div class="tooltip-content">Kendaraan yang pertama kali melakukan servis di H2 berdasarkan lokasi dealer
              </div>
            </div>
          </div>
          <div class="d-flex ml-auto">
            <Multiselect v-model="selectedDealer" class="mt-1 ml-2" :options="optionDealers" placeholder="All Dealer"
              style="width: 200px"></Multiselect>
            <Multiselect v-model="selectedYearDealer" class="mt-1 ml-2"
              :options="optionYears.filter(y => y !== 'Unknown' || !showPerformanceYear)" placeholder="All Years"
              style="width: 200px" @change="selectedYearDealer"></Multiselect>
            <button
              class="replacement-download btn btn-outline-secondary ml-2 d-flex align-items-center justify-content-center"
              @click="downloadExcelDealer()" style="width: 150px; height: 40px; margin-top: 4px">
              Download CSV
              <i class="ml-2 fa-solid fa-file-arrow-down"></i>
            </button>
          </div>
        </div>
        <div v-if="isLoadingDealer" class="loading text-center h-100 d-flex align-items-center justify-content-center">
          <img src="/img/loading.gif" width="48" height="48" :alt="`Loading ${registrationType} Dealer`" />
        </div>
        <div v-else>
          <table class="table">
            <thead>
              <tr>
                <th class="hso-table-header" style="background-color: #ffffff">Dealer Name</th>
                <th v-for="(year, index) in optionYears.filter(y => y !== 'Unknown' || !showPerformanceYear)"
                  :key="index"
                  v-if="!selectedYearDealer || selectedYearDealer === 'All Years' || selectedYearDealer === year"
                  class="hso-table-header" style="background-color: #ffffff">
                  {{ year }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="dataDealer.length === 0">
                <td colspan="100%" style="padding: 2rem 0">
                  <p style="font-weight: bold; font-size: 1.5rem; line-height: 1">No Data Available.</p>
                  <p style="margin-top: -0.5rem">Please choose another time or option</p>
                </td>
              </tr>
              <tr v-else v-for="(dealerData, dealerName) in dealerPaginatedData" :key="dealerName">
                <td class="hso-table-body" style="border-bottom: none; border-top: none">{{ dealerName }}</td>
                <td v-for="(year, index) in optionYears.filter(y => y !== 'Unknown' || !showPerformanceYear)"
                  :key="index"
                  v-if="!selectedYearDealer || selectedYearDealer === 'All Years' || selectedYearDealer === year"
                  class="hso-table-body" style="border-bottom: none; border-top: none">
                  <template v-if="year === optionYears[optionYears.length - 2]"> {{
                    getDealerValueForOlderYears(dealerData, parseInt(year.replace("<=", ""))) }} </template>
                      <template v-else>
                        {{ getDealerValueForYear(dealerData, year) }}
                      </template>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- New ID Dealer Pagination -->
          <div class="d-flex justify-content-between align-items-center mt-3">
            <div class="hso-table-pagination">Showing {{ dealerPaginationStart + 1 }} to {{ dealerPaginationEnd }} of {{
              filteredDealerTotalItems }} entries</div>
            <b-pagination v-model="dealerCurrentPage" :total-rows="filteredDealerTotalItems"
              :per-page="dealerRowsPerPage" aria-controls="dealer-table"></b-pagination>
          </div>
        </div>
      </b-card>

      <!-- End -->
    </div>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import flatPickr from "vue-flatpickr-component";
import moment from "moment";
import Multiselect from "vue-multiselect";
import { FoldSpinner } from "vue-spinners";
import NewIdChartStackedColumn from "./childComponents/NewIdChartStackedColumn";
import NewIdChartOverallProductionYear from "./childComponents/NewIdChartOverallProductionYear";
import NewIdChartSegment from "./childComponents/NewIdChartSegment";
import ExistingIdChartStackedColumn from "./childComponents/ExistingIdChartStackedColumn";
import ExistingIdChartOverallProductionYear from "./childComponents/ExistingIdChartOverallProductionYear";
import ExistingIdChartSegment from "./childComponents/ExistingIdChartSegment";
import Tooltip from "./childComponents/Tooltip.vue";
import XLSX from "xlsx";
import { ToggleButton } from "vue-js-toggle-button";
import NewIdChartPerfomanceComparison from "./childComponents/NewIdChartPerfomanceComparison.vue";
import ExistingIdChartPerfomanceComparison from "./childComponents/ExistingIdChartPerfomanceComparison.vue";
import "flatpickr/dist/flatpickr.css";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect"; // Import the monthSelect plugin
import "flatpickr/dist/plugins/monthSelect/style.css"; // Import the plugin's CSS
import VueSweetalert2 from "vue-sweetalert2";

export default {
  name: "q-registration",
  metaInfo: {
    title: "QR Registration",
  },
  data() {
    return {
      registrationType: "New ID",
      cachedData: {
        "New ID": {}, // Cache for New ID
        "Existing ID": {}, // Cache for Existing ID
      },

      // Comparison
      firstRange: null,
      secondRange: null,
      formattedFirstRange: "",
      formattedSecondRange: "",
      monthYearConfig: {
        plugins: [
          new monthSelectPlugin({
            shorthand: true,
            dateFormat: "M Y",
            altFormat: "M Y",
            theme: "light",
          }),
        ],
        mode: "range",
        altInput: true,
        altFormat: "M Y",
        dateFormat: "Y-m",
      },

      // Top Navigation
      rangeConfig: {
        mode: "range",
        altInput: true,
        altInputClass: "form-control input elegant-flatpickr",
        dateFormat: "Y-m-d",
        onChange: this.onDateChange,
        defaultDate: [
          moment().startOf("year").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ], // Set default start & end dates
        date_filter: true,
        altFormat: "m/d/Y", // Changes the display format to MM/DD/YYYY
        locale: {
          months: {
            shorthand: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
            longhand: [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ],
          },
        },
      },

      dateRange: {
        date: null,
        start: moment().startOf("year").format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD"),
      },
      selectedComparisonRegion: null,
      //toggle
      showPerformanceYear: false,

      optionYears: [],
      selectedYearGlobal: null,

      // Chart Stacked
      isLoadingChartStacked: false,
      optionChartStacked: [],
      selectedChartStacked: null,
      dataChartStacked: null,

      // Chart Overall Production Year
      isLoadingOverallProductionYear: false,
      dataChartOverallProductionYear: null,

      //Chart Comparisom
      optionComparisonRegion: [],
      selectedComparisonRegion: null,
      firstRange: null, // Holds the raw first range 
      secondRange: null, // Holds the raw second range 
      formattedFirstRange: "", // Holds the formatted first range 
      formattedSecondRange: "", // Holds the formatted second range 
      monthYearConfig: {
        plugins: [
          new monthSelectPlugin({
            shorthand: true, // Use shorthand for month names (e.g., "Jan" instead of "January")
            dateFormat: "M Y", // Format the selected date as "Month Year"
            altFormat: "M Y", // Display the selected date in the input as "Month Year"
            theme: "light", // Optional: Customize the theme
          }),
        ],
        mode: "range", // Allow selecting a range of months
        altInput: true, // Show the formatted date in the input
        altFormat: "M Y", // Display the selected range as "Jan 2023 to Mar 2023"
        dateFormat: "Y-m", // Internal format for the selected date
      },
      // Segments
      isLoadingSegment: false,
      optionSegments: [],
      selectedSegment: null,
      selectedYearSegment: null, // This is for the Segment section
      dataSegment: null,

      // Regions
      isLoadingRegion: false,
      optionRegions: [],
      selectedRegion: null,
      selectedYearRegion: null,
      dataRegion: null,

      // Dealers
      isLoadingDealer: false,
      optionDealers: [],
      selectedDealer: null,
      selectedYearDealer: null,
      dataDealer: {},
      dealerCurrentPage: 1,
      dealerRowsPerPage: 20,

      isLoading: false,
      fetchedTabs: {},

      months: ["January", "February", "March", "April", "May", "June", "July"],
      displayedMonths: [],

      currentPage: 1,
      rowsPerPage: 20,
    };
  },
  watch: {
    "dateRange.start": function () {
      this.fetchRegistrationChartStacked();
      this.fetchRegistrationOverallProductionYear();
      this.fetchRegistrationSegment();
      this.fetchRegistrationRegion();
      this.fetchRegistrationDealer();
    },
    "dateRange.end": function () {
      this.fetchRegistrationChartStacked();
      this.fetchRegistrationOverallProductionYear();
      this.fetchRegistrationSegment();
      this.fetchRegistrationRegion();
      this.fetchRegistrationDealer();
    },
    selectedChartStacked(newDealer) {
      this.fetchRegistrationChartStacked();
    },
    selectedSegment() {
      this.fetchRegistrationSegment();
    },
    selectedYearSegment() {
      this.fetchRegistrationSegment();
    },
    selectedRegion() {
      this.fetchRegistrationRegion();
      this.currentPage = 1;
    },
    selectedYearRegion() {
      this.fetchRegistrationRegion();
      this.currentPage = 1;
    },
    selectedDealer() {
      this.resetPagination();
      this.fetchRegistrationDealer();
      this.dealerCurrentPage = 1;
    },
    selectedYearDealer(year) {
      // console.log(year);
      this.fetchRegistrationDealer();
      this.dealerCurrentPage = 1;
    },
    //hanya jika toggle aktif
    showPerformanceYear(newValue) {
      // this.getYears();
      this.fetchRegistrationChartStacked();
      this.fetchRegistrationDealer();
      this.fetchRegistrationOverallProductionYear();
      // this.fetchRegistrationSegment();
      // this.fetchRegistrationRegion();
      // this.fetchRegistrationDealer();
    },
  },
  components: {
    flatPickr,
    Multiselect,
    fold: FoldSpinner,
    NewIdChartStackedColumn,
    NewIdChartOverallProductionYear,
    NewIdChartSegment,
    ExistingIdChartStackedColumn,
    ExistingIdChartOverallProductionYear,
    ExistingIdChartSegment,
    Tooltip,
    ToggleButton,
    ExistingIdChartPerfomanceComparison,
    NewIdChartPerfomanceComparison,
  },
  computed: {
    formattedRegion() {
      return this.selectedRegion ? this.selectedRegion.split(" - ")[0] : "";
    },
    yearPlaceholder() {
      return this.showPerformanceYear ? "Performance Years" : "All Years";
    },
    todayPlaceholder() {
      return moment().format("DD MMM,YYYY");
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.rowsPerPage;
      const end = start + this.rowsPerPage;
      return Object.fromEntries(Object.entries(this.filteredRegistrationData).slice(start, end));
    },
    totalItems() {
      return Object.keys(this.filteredRegistrationData && this.filteredRegistrationData).length;
    },
    paginationStart() {
      return (this.currentPage - 1) * this.rowsPerPage;
    },
    paginationEnd() {
      return Math.min(this.paginationStart + this.rowsPerPage, this.totalItems);
    },

    dealerPaginatedData() {
      const start = (this.dealerCurrentPage - 1) * this.dealerRowsPerPage;
      const end = start + this.dealerRowsPerPage;
      return Object.fromEntries(Object.entries(this.filteredDealerData).slice(start, end));
    },
    dealerTotalItems() {
      return Object.keys(this.dataDealer).length;
    },
    dealerPaginationStart() {
      return (this.dealerCurrentPage - 1) * this.dealerRowsPerPage;
    },
    dealerPaginationEnd() {
      return Math.min(this.dealerPaginationStart + this.dealerRowsPerPage, this.filteredDealerTotalItems);
    },
    optionDealers() {
      return this.dataDealer ? Object.keys(this.dataDealer) : [];
    },
    filteredDealerData() {
      let filtered = { ...this.dataDealer };

      if (this.selectedDealer) {
        filtered = {
          [this.selectedDealer]: filtered[this.selectedDealer],
        };
      }

      if (yearSelected === "All Years") {
        return filtered; // Return all filtered data for all years
      }

      const yearSelected = this.selectedYearDealer;
      if (yearSelected && yearSelected !== "All Years") {
        Object.keys(filtered).forEach((dealer) => {
          if (Array.isArray(filtered[dealer])) {
            filtered[dealer] = filtered[dealer].filter((item) => {
              const lastYearInOptions = this.optionYears[this.optionYears.length - 2];
              const cutoffYear = parseInt(lastYearInOptions.replace("<=", ""));

              if (this.selectedYearDealer === lastYearInOptions) {
                return item.year_group === "Older" || parseInt(item.year_group) <= cutoffYear;
              }
              return item.year_group.toString() === this.selectedYearDealer.toString();
            });
          } else {
            filtered[dealer] = []; // Set to empty array if no data
          }
        });
      }

      return filtered;
    },

    filteredDealerTotalItems() {
      return Object.values(this.filteredDealerData).reduce((total, dealerData) => total + (dealerData.length || 0), 0);
    },

    filteredRegistrationData() {
      if (!this.selectedRegion) {
        return this.dataRegion;
      }
      return {
        [this.selectedRegion]: this.dataRegion[this.selectedRegion],
      };
    },
  },
  mounted() {
    this.switchRegistrationType(this.registrationType); // fetch data for first init
    this.getYears();
  },
  methods: {
    transformDataForPerformanceYear(rawData) {
      const transformed = [];
      const groupedByMonth = rawData.reduce((acc, item) => {
        const month = item.bulan; 
        if (!acc[month]) {
          acc[month] = [];
        }
        acc[month].push(item);
        return acc;
      }, {});

      Object.keys(groupedByMonth).forEach((month) => {
        const monthData = groupedByMonth[month];
        const transformedData = { month }; 

        monthData.forEach((item) => {
          transformedData[item.tahun] = item.value;
        });

        transformed.push(transformedData);
      });

      return transformed;
    },
    // Transform the raw range into the desired format (e.g., "Jan-Mar 2023")
    transformRange(rawRange) {
      if (!rawRange) return "";

      // Split the range into start and end parts
      const [start, end] = rawRange.split(" to ");

      if (!start || !end) return "";

      // Extract the month and year from the start and end dates
      const startMonth = start.split(" ")[0]; 
      const endMonth = end.split(" ")[0]; 
      const year = end.split(" ")[1]; 

      // Return the formatted range
      return `${startMonth}-${endMonth} ${year}`;
    },
    // Update the formatted first range when the picker changes
    updateFirstRange(selectedDates, dateStr) {
      this.formattedFirstRange = this.transformRange(dateStr);
      if (this.formattedFirstRange) {
        this.secondRangeWarning = false;
      }
    },
    // Update the formatted second range when the picker changes
    updateSecondRange(selectedDates, dateStr) {
      this.formattedSecondRange = this.transformRange(dateStr);
      if (this.formattedSecondRange) {
        this.firstRangeWarning = false;
      }
    },
    // Transform the raw range into the desired format
    transformRange(rawRange) {
      if (!rawRange) return "";

      // Split the range into start and end parts
      const [start, end] = rawRange.split(" to ");

      if (!start || !end) return "";

      // Extract the month and year from the start and end dates
      const startMonth = start.split(" ")[0]; // e.g., "Jan"
      const endMonth = end.split(" ")[0]; // e.g., "Mar"
      const year = end.split(" ")[1]; // e.g., "2023"

      // Return the formatted range
      return `${startMonth}-${endMonth} ${year}`;
    },
    // Update the formatted first range when the picker changes
    updateFirstRange(selectedDates, dateStr) {
      this.formattedFirstRange = this.transformRange(dateStr);
    },
    // Update the formatted second range when the picker changes
    updateSecondRange(selectedDates, dateStr) {
      this.formattedSecondRange = this.transformRange(dateStr);
    },
    // Handle toggle change
    onToggleChange(newValue) {
      this.showPerformanceYear = value;
      this.getYears();
      // Fetch data berdasarkan status toggle
      this.fetchRegistrationChartStacked();
      this.fetchRegistrationOverallProductionYear();
      // this.fetchRegistrationSegment();
      // this.fetchRegistrationRegion();
      this.fetchRegistrationDealer();
    },

    switchRegistrationType(type) {
      // console.log(`Switching to: ${type}`);
      this.registrationType = type;

      // Reset data when switching tabs
      this.dataChartStacked = null;
      this.dataChartOverallProductionYear = null;
      this.dataSegment = null;
      this.dataRegion = null;
      this.dataDealer = {};

      // Define selectedYear based on the section, prioritizing dealer-specific year
      const selectedYear = this.selectedYearDealer || this.selectedYearRegion || this.selectedYearSegment || this.selectedYearGlobal;

      // console.log("Selected Year for Cache:", selectedYear);
      // console.log("Current Cached Data for Registration Type:", this.cachedData[this.registrationType]);

      // Load cached data if available
      const cachedData = this.cachedData[this.registrationType];
      const cached = cachedData[selectedYear];

      if (cached) {
        // Ensure the cached properties exist before accessing them
        this.dataChartStacked = cached.dataChartStacked || [];
        this.dataChartOverallProductionYear = cached.dataChartOverallProductionYear || [];
        this.dataSegment = cached.dataSegment || [];
        this.dataRegion = cached.dataRegion || {};
        this.dataDealer = cached.dataDealer || {};

        // console.log("Loaded from cache - Stacked Chart:", this.dataChartStacked);
        // console.log("Loaded from cache - Overall Production Year Chart:", this.dataChartOverallProductionYear);
        // console.log("Loaded from cache - Segment:", this.dataSegment);
        // console.log("Loaded from cache - Region:", this.dataRegion);
        // console.log("Loaded from cache - Dealer:", this.dataDealer);
      } else {
        // console.log("No cache found, fetching data...");
        this.fetchRegistrationChartStacked();
        this.fetchRegistrationChartStackedOptions();
        this.fetchComparisonRegionOptions();
        this.fetchRegistrationOverallProductionYear();
        this.fetchRegistrationSegment();
        this.fetchOptionSegments();
        this.fetchRegistrationRegion();
        this.fetchRegistrationDealer();
      }
    },
    selectGlobalYear() {
      // Trigger fetching for each section individually based on their years
      this.fetchRegistrationChartStacked();
      this.fetchRegistrationOverallProductionYear();
      // this.fetchRegistrationDealer();

      // When global year changed, also change each section year.
      this.selectedYearSegment = this.selectedYearGlobal;
      this.selectedYearRegion = this.selectedYearGlobal;
      this.selectedYearDealer = this.selectedYearGlobal;
      // console.log(`Parent selectedYearGlobal: ${this.selectedYearGlobal}`);
    },

    onYearSelected(selectedYear) {
      this.selectedYearDealer = selectedYear;
      this.resetPagination(); // Reset pagination when a year is selected
    },
    resetPagination() {
      this.dealerCurrentPage = 1; // Reset to first page
    },

    getYears() {
      const currentYear = new Date().getFullYear();
      const cutoffYear = currentYear - 3; // Dynamically calculate cutoff year for older years

      this.optionYears = [
        // "All Years",
        currentYear, // Current year
        currentYear - 1, // One year prior
        currentYear - 2, // Two years prior
        `<=${cutoffYear}`, // Dynamically generate older year group
        // `Unknown`,
      ];
      // Tambahkan "Unknown" hanya jika toggle tidak aktif
      if (!this.showPerformanceYear) {
        this.optionYears.push("Unknown");
      }
    },
    // begin stacked column chart
    fetchRegistrationChartStacked() {
      this.isLoadingChartStacked = true; // Show loading indicator

      const selectedYear = this.selectedYearGlobal; // Use global year as there's no specific per section year

      // Ensure cache is initialized for registration type and year
      if (!this.cachedData[this.registrationType]) {
        this.cachedData[this.registrationType] = {};
      }

      if (!this.cachedData[this.registrationType][selectedYear]) {
        this.cachedData[this.registrationType][selectedYear] = {};
      }

      const params = {};

      // Add parameters based on user selection
      // if (selectedYear !== "All Years") {
      //   params.manufacture_year = selectedYear;
      // }
      if (this.dateRange.start) {
        params.start = this.dateRange.start;
      }
      if (this.dateRange.end) {
        params.end = this.dateRange.end;
      }
      // Logika toggle showPerformanceYear
      if (this.showPerformanceYear) {
        // Jika toggle aktif, tambahkan show_performance_year
        params.show_performance_year = true;
      } else {
        // Jika toggle tidak aktif, tambahkan manufacture_year (jika selectedYear bukan "All Years")
        if (selectedYear !== "All Years") {
          params.manufacture_year = selectedYear;
        }
      }
      // Ensure the cache is initialized for selectedDealer
      if (this.selectedChartStacked) {
        params.dealer = this.selectedChartStacked.loc_code; // Use only dealer code from selectedChartStacked
        // console.log("Selected dealer code (loc_code):", params.dealer);
      }

      // Define the URL based on the registration type
      let url;
      if (this.registrationType === "New ID") {
        url = "/api/distribution/qr-registration/new-id";
      } else {
        url = "/api/distribution/qr-registration/existing-id";
      }

      // Proses panggilan API
      this.$http
        .get(url, { params })
        .then((response) => {
          if (response.data.status === "success") {
            // Ubah data sesuai dengan status toggle
            if (this.showPerformanceYear) {
              // Jika toggle aktif, ubah data ke format untuk toggle aktif
              this.dataChartStacked = this.transformDataForPerformanceYear(response.data.data);
            } else {
              // Jika toggle tidak aktif, gunakan format data yang lama
              this.dataChartStacked = this.convertToChartData(response.data.data, selectedYear);
            }

            // Simpan data yang sudah ditransformasi ke cache
            this.cachedData[this.registrationType][selectedYear].dataChartStacked = this.dataChartStacked;
            this.isLoadingChartStacked = false; // Sembunyikan indikator loading
          } else {
            console.error("Error fetching data:", response.data.message);
          }
        })
        .catch((error) => {
          console.error("Error fetching stacked chart data:", error);
          this.isLoadingChartStacked = false; // Sembunyikan indikator loading jika terjadi error
        });
    },
    // Transform API data into stacked new id existing id data
    convertToChartData(rawData, selectedYear = null) {
      const chartData = [];

      Object.keys(rawData).forEach((month) => {
        const cleanedMonth = month.replace("2024", "").trim(); // Bersihkan format bulan
        const monthData = rawData[month]; // Data untuk bulan tertentu
        const transformedData = { month: cleanedMonth }; // Inisialisasi objek dengan bulan yang sudah dibersihkan

        // Filter berdasarkan selectedYear
        const filteredMonthData = monthData;
        // .filter((data) => {
        //   const key = data.year_group || data.segment || "Unknown";
        //   return (selectedYear === "Unknown" && key === "Unknown") || selectedYear === "All Years" || key !== "Unknown";
        // });

        if (filteredMonthData.length > 0) {
          filteredMonthData.forEach((data) => {
            const key = data.year_group || data.segment || "Unknown";
            transformedData[key] = data.value;
          });
          chartData.push(transformedData);
        }
      });

      return chartData.length ? chartData : [{}];
    },
    fetchRegistrationChartStackedOptions() {
      axios
        .get("/api/master/branch")
        .then((response) => {
          if (response.data.status === "success") {
            this.optionChartStacked = response.data.data.map((dealer) => ({
              loc_code: dealer.loc_code,
              label: `${dealer.loc_code} - ${dealer.name}`,
            }));
          } else {
            // console.error("Error fetching chart dealer options:", response.data.message);
          }
        })
        .catch((error) => {
          // console.error("Error fetching chart dealer options:", error);
        });
    },
     fetchComparisonRegionOptions() {
      axios
        .get("/api/master/regions")
        .then((response) => {
          if (response.data.status === "success") {
            this.optionComparisonRegion = response.data.data.map((region) => ({
              loc_code: region.loc_code,
              name:`${region.loc_code} - ${region.name}`,
            }));
          } else {
            // console.error("Error fetching chart dealer options:", response.data.message);
          }
        })
        .catch((error) => {
          // console.error("Error fetching chart dealer options:", error);
        });
    },

    onChartDealerChange(value) {
      this.selectedChartStacked = value; // Ensure selectedChartStacked is updated
      // console.log("Dealer selected in Multiselect:", value);
    },

    fetchRegistrationOverallProductionYear() {
      this.isLoadingOverallProductionYear = true; // Show loading indicator
      const selectedYear = this.selectedYearGlobal; // Use global year for fetching

      // Ensure cache is initialized for registration type and year
      if (!this.cachedData[this.registrationType]) {
        this.cachedData[this.registrationType] = {};
      }
      if (!this.cachedData[this.registrationType][selectedYear]) {
        this.cachedData[this.registrationType][selectedYear] = {};
      }

      const params = {};
      // Add parameters based on user selection
      // if (selectedYear !== "All Years") {
      //   params.manufacture_year = selectedYear;
      // }
      if (this.dateRange.start) {
        params.start = this.dateRange.start;
      }
      if (this.dateRange.end) {
        params.end = this.dateRange.end;
      }
      // Logika toggle showPerformanceYear
      if (this.showPerformanceYear) {
        // Jika toggle aktif, tambahkan show_performance_year
        params.show_performance_year = true;
      } else {
        // Jika toggle tidak aktif, tambahkan manufacture_year (jika selectedYear bukan "All Years")
        if (selectedYear !== "All Years") {
          params.manufacture_year = selectedYear;
        }
      }
      let url;
      if (this.registrationType === "New ID") {
        url = "/api/distribution/qr-registration/new-id-by-production-year";
      } else {
        url = "/api/distribution/qr-registration/existing-id-by-production-year";
      }

      this.$http
        .get(url, { params })
        .then((response) => {
          if (response.data.status === "success") {
            this.dataChartOverallProductionYear = response.data.data; // Update chart data with fetched data
            this.isLoadingOverallProductionYear = false; // Hide loading indicator
            // Cache the fetched data
            this.cachedData[this.registrationType][selectedYear].dataChartOverallProductionYear = response.data.data;
          } else {
            // console.error("Error fetching data:", response.data.message);
            this.isLoadingOverallProductionYear = false; // Hide loading indicator in case of error
          }
        })
        .catch((error) => {
          // console.error("Error fetching production year data:", error);
          this.isLoadingOverallProductionYear = false; // Hide loading indicator in case of error
        });
    },

    fetchOptionSegments() {
      this.isLoading = true; // Show loading indicator

      // Ensure cache is initialized for registration type
      if (!this.cachedData[this.registrationType]) {
        this.cachedData[this.registrationType] = {};
      }

      // Check if segment options are already cached for the registration type
      if (this.cachedData[this.registrationType].optionSegments) {
        this.optionSegments = this.cachedData[this.registrationType].optionSegments;
        this.isLoading = false;
        return;
      }

      this.$http
        .get("/api/master/segment")
        .then((response) => {
          if (response.data.status === "success") {
            this.optionSegments = response.data.data.map((item) => item.segment);

            // Cache the fetched data
            this.cachedData.optionSegments = this.optionSegments;

            this.isLoading = false; // Hide loading indicator
          } else {
            // console.error("Error fetching segment options:", response.data.message);
            this.isLoading = false; // Hide loading indicator in case of error
          }
        })
        .catch((error) => {
          // console.error("Error fetching segment options:", error);
          this.isLoading = false; // Hide loading indicator in case of error
        });
    },
    fetchRegistrationSegment() {
      this.isLoadingSegment = true; // Show loading indicator
      // const selectedYear = this.selectedYearSegment || this.selectedYearGlobal;
      const selectedYear = this.selectedYearSegment === null ? null : this.selectedYearSegment || this.selectedYearGlobal;

      // Ensure cache is initialized for registration type and year
      if (!this.cachedData[this.registrationType]) {
        this.cachedData[this.registrationType] = {};
      }
      if (!this.cachedData[this.registrationType][selectedYear]) {
        this.cachedData[this.registrationType][selectedYear] = {};
      }
      const params = {};
      // Add parameters based on user selection
      if (selectedYear !== "All Years") {
        params.manufacture_year = selectedYear;
      }
      if (this.dateRange.start) {
        params.start = this.dateRange.start;
      }
      if (this.dateRange.end) {
        params.end = this.dateRange.end;
      }
      if (this.selectedSegment && this.selectedSegment.length > 0) {
        params.segment = this.selectedSegment.join(","); // Use joined segments
      }
      let url;
      if (this.registrationType === "New ID") {
        url = "/api/distribution/qr-registration/new-id-by-segment";
      } else {
        url = "/api/distribution/qr-registration/existing-id-by-segment";
      }

      this.$http
        .get(url, { params })
        .then((response) => {
          if (response.data.status === "success") {
            this.dataSegment = this.convertToChartData(response.data.data); // Convert to chart data so it'll be chart friendly
            // console.log("Transformed Segment Data:", this.dataSegment);
            this.isLoadingSegment = false; // Hide loading indicator
            // Cache the fetched data
            this.cachedData[this.registrationType][selectedYear].dataSegment = this.dataSegment;
          } else {
            // console.error("Error fetching segment data:", response.data.message);
            this.isLoading = false; // Hide loading indicator in case of error
          }
        })
        .catch((error) => {
          // console.error("Error fetching segment data:", error);
          this.isLoading = false; // Hide loading indicator in case of error
        });
    },
     fetchRegistrationRegion() {
      this.isLoadingRegion = true; // Show loading indicator
      this.dataRegion = ""; // Reset to an empty string to avoid stale data
      // const selectedYear = this.selectedYearRegion || this.selectedYearGlobal;
      const selectedYear = this.selectedYearRegion === null ? null : this.selectedYearRegion || this.selectedYearGlobal;

      // Ensure cache is initialized for registration type and year
      if (!this.cachedData[this.registrationType]) {
        this.cachedData[this.registrationType] = {};
      }
      if (!this.cachedData[this.registrationType][selectedYear]) {
        this.cachedData[this.registrationType][selectedYear] = {};
      }

      const params = {};
      if (selectedYear !== "All Years") params.manufacture_year = selectedYear;
      if (this.dateRange.start) params.start = this.dateRange.start;
      if (this.dateRange.end) params.end = this.dateRange.end;
      if (this.selectedRegion) params.region = this.selectedRegion.split(" - ")[0];

      const url = this.registrationType === "New ID" ? "/api/distribution/qr-registration/new-id-by-region" : "/api/distribution/qr-registration/existing-id-by-region";

      // console.log(params);
      this.$http
        .get(url, { params })
        .then((response) => {
          this.isLoadingRegion = false;

          if (response.data.status === "success" && response.data.data) {
            this.dataRegion = response.data.data;

            if (!params.region) {
              this.optionRegions = Object.keys(this.dataRegion); // Store the keys
            }

            if (this.optionRegions.length === 0) {
              this.dataRegion = ""; // Handle empty response
            } else {
              // Cache the data
              this.cachedData[this.registrationType][selectedYear].dataRegion = this.dataRegion;
            }

            this.currentPage = 1;
            this.updateDisplayedMonths(); // Update months display
          } else {
            // console.error("Error fetching data:", response.data.message);
            this.isLoadingRegion = false;
            this.dataRegion = ""; // Handle API error
          }
        })
        .catch((error) => {
          // console.error("Error fetching registration region data:", error);
          this.isLoadingRegion = false;
          this.dataRegion = ""; // Handle fetch error
        });
    },
    updateDisplayedMonths() {
      if (Object.keys(this.dataRegion).length > 0) {
        const firstRegionData = this.dataRegion[Object.keys(this.dataRegion)[0]];
        this.displayedMonths = firstRegionData
          .map((item) => item.bulan)
          .sort((a, b) => {
            const monthOrder = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            return monthOrder.indexOf(a) - monthOrder.indexOf(b);
          });
      } else {
        this.displayedMonths = [];
      }
    },
    onDateChange(selectedDates) {
      if (selectedDates.length === 2) {
        this.dateRange.start = moment(selectedDates[0]).format("YYYY-MM-DD");
        this.dateRange.end = moment(selectedDates[1]).format("YYYY-MM-DD");

        // if (this.registrationType === "New ID") {
        //   this.fetchRegistrationRegion();
        //   this.fetchRegistrationDealer();
        //   this.fetchRegistrationSegment();
        // } else {
        //   this.fetchExistingDataRegion();
        //   this.fetchExistingDealer();
        //   this.fetchRegistrationSegment();
        // }
      }
    },

    getValueForMonth(regionData, month) {
      const monthData = regionData.find((item) => item.bulan === month);
      return monthData ? monthData.value.toLocaleString() : "-";
    },
    fetchRegistrationDealer() {
      this.isLoadingDealer = true; // Show loading indicator
      this.dataDealer = []; // Reset to an empty array to avoid stale data
      this.dealerCurrentPage = 1;

      // const selectedYear = this.selectedYearDealer || this.selectedYearGlobal;
      const selectedYear = this.selectedYearDealer === null ? null : this.selectedYearDealer || this.selectedYearGlobal;
      // console.log(selectedYear);
      // Ensure cache is initialized for registration type and year
      if (!this.cachedData[this.registrationType]) {
        this.cachedData[this.registrationType] = {};
      }
      if (!this.cachedData[this.registrationType][selectedYear]) {
        this.cachedData[this.registrationType][selectedYear] = {};
      }

      const params = {};
      // if (selectedYear) params.manufacture_year = selectedYear;
      if (this.dateRange.start) params.start = this.dateRange.start;
      if (this.dateRange.end) params.end = this.dateRange.end;
      if (this.selectedDealer) {
        const dealerCode = this.selectedDealer.split(" - ")[0];
        const dealerParts = dealerCode.split("/");
        params.dealer = dealerParts[0];
      }
      // Logika toggle showPerformanceYear
      if (this.showPerformanceYear) {
        // Jika toggle aktif, tambahkan show_performance_year
        params.show_performance_year = true;
        if (selectedYear !== "All Years") {
          params.manufacture_year = selectedYear;
        }
      } else {
        // Jika toggle tidak aktif, tambahkan manufacture_year (jika selectedYear bukan "All Years")
        if (selectedYear !== "All Years") {
          params.manufacture_year = selectedYear;
        }
      }

      // Tambahkan nilai `fromCache` berdasarkan status toggle
      // params.fromCache = this.selected.date_filter ? true : false;

      const url = this.registrationType === "New ID" ? "/api/distribution/qr-registration/new-id-by-dealer" : "/api/distribution/qr-registration/existing-id-by-dealer";

      this.$http
        .get(url, { params })
        .then((response) => {
          this.isLoadingDealer = false; // Stop loading indicator

          if (response.data.status === "success" && response.data.data) {
            this.dataDealer = response.data.data; // Populate data

            if (!params.dealer) {
              this.optionDealers = Object.keys(this.dataDealer); // Store the keys
            }

            if (this.optionDealers.length === 0) {
              this.dataDealer = []; // Handle empty response
            } else {
              // Cache the data
              this.cachedData[this.registrationType][selectedYear].dataDealer = this.dataDealer;
            }

            this.dealerCurrentPage = 1;
            this.updateDisplayedMonths(); // Update months display
          } else {
            // console.error("Error fetching data:", response.data.message);
            this.isLoadingDealer = false;
            this.dataDealer = []; // Reset to empty array on error
            this.optionDealers = []; // Clear optionDealers on error
          }
        })
        .catch((error) => {
          // console.error("Error fetching dealer data:", error);
          this.isLoadingDealer = false; // Stop loading
          this.dataDealer = []; // Handle fetch error
          this.optionDealers = []; // Clear optionDealers on fetch error
        });
    },
    getDealerValueForYear(dealerData, year) {
      if (year === "All Years") {
        return null;
      }
      if (!dealerData || !Array.isArray(dealerData)) {
        // console.log("Invalid dealer data for year:", year);
        return "0";
      }

      // Convert both year_group and year to strings for comparison
      const yearData = dealerData.find((item) => item.year_group.toString() === year.toString());

      return yearData ? yearData.value.toLocaleString() : "0";
    },
    getDealerValueForOlderYears(dealerData, cutoffYear) {
      if (!dealerData || !Array.isArray(dealerData)) {
        return "0"; // Return 0 if no data is available
      }

      // Filter for years that are "Older" or <= cutoffYear
      const olderYears = dealerData.filter((item) => item.year_group === "Older" || parseInt(item.year_group) <= cutoffYear);

      // Sum the values of all older years
      const total = olderYears.reduce((sum, item) => sum + item.value, 0);

      return total ? parseInt(total).toLocaleString() : "0"; // Return the total sum as a formatted string
    },

    selectedYearDealer(year) {
      // Check if the user has unselected the year
      if (!year || year === "All Years") {
        // Set the year to "All Years" if no year is selected
        this.selectedYearDealer = "All Years";
        // Fetch all dealer data
        this.fetchRegistrationDealer();
      } else {
        // Update the selected year
        this.selectedYearDealer = year;
        // Fetch dealer data based on the new year selection
        this.fetchRegistrationDealer();
      }

      this.dealerCurrentPage = 1; // Reset current page
    },
    showTooltip() {
      this.$refs.tooltip.showTooltip();
    },
    hideTooltip() {
      this.$refs.tooltip.hideTooltip();
    },

    async downloadComparison() {
      try {
        if (!this.firstRange || !this.secondRange) {
          this.$swal.fire({
            html: `<svg width="384" height="186" viewBox="0 0 384 186" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M192 0.516602C227.321 0.516602 256 29.284 256 64.7152C256 100.146 227.321 128.914 192 128.914C156.678 128.914 128 100.146 128 64.7152C128 29.284 156.678 0.516602 192 0.516602Z" fill="#EFF3FF"/>
                    <mask id="mask0_2415_2655" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="141" y="14" width="102" height="102">
                    <path d="M141.647 14.2061H242.352V115.223H141.647V14.2061Z" fill="white"/>
                    </mask>
                    <g mask="url(#mask0_2415_2655)">
                    <path d="M191.999 16.4883C218.533 16.4883 240.077 38.099 240.077 64.7158C240.077 91.3326 218.533 112.943 191.999 112.943C165.465 112.943 143.921 91.3326 143.921 64.7158C143.921 38.099 165.465 16.4883 191.999 16.4883Z" fill="#3691FF"/>
                    <path d="M166.586 72.2054V75.795C166.586 80.1316 170.091 83.6472 174.414 83.6472H209.584C213.907 83.6472 217.412 80.1316 217.412 75.795V71.4482" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M191.999 40.7158V73.5519" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M204.295 61.2148L191.996 73.5516L179.703 61.2203" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <path d="M232.147 89.4268C242.889 89.4268 251.611 98.1744 251.611 108.948C251.611 119.722 242.889 128.47 232.147 128.47C221.405 128.47 212.684 119.722 212.684 108.948C212.684 98.1744 221.405 89.4268 232.147 89.4268Z" fill="#FF7C80"/>
                    <path d="M240.677 102.724L237.946 99.9932L231.863 106.2L225.781 99.9932L223.05 102.724L229.257 108.807L223.05 114.889L225.781 117.62L231.863 111.414L237.946 117.62L240.677 114.889L234.47 108.807L240.677 102.724Z" fill="white"/>
                    <path d="M100.289 141.369H102.924V150.871C102.924 151.913 102.678 152.829 102.186 153.62C101.698 154.411 101.011 155.029 100.126 155.474C99.2405 155.914 98.2059 156.134 97.0222 156.134C95.8337 156.134 94.7968 155.914 93.9114 155.474C93.026 155.029 92.3394 154.411 91.8517 153.62C91.3641 152.829 91.1202 151.913 91.1202 150.871V141.369H93.7551V150.651C93.7551 151.257 93.8877 151.797 94.1529 152.271C94.4228 152.744 94.8016 153.116 95.2892 153.386C95.7769 153.651 96.3546 153.783 97.0222 153.783C97.6898 153.783 98.2675 153.651 98.7551 153.386C99.2476 153.116 99.6264 152.744 99.8915 152.271C100.157 151.797 100.289 151.257 100.289 150.651V141.369ZM108.246 149.522V155.914H105.675V145.005H108.132V146.859H108.26C108.511 146.248 108.911 145.763 109.46 145.403C110.014 145.043 110.698 144.863 111.513 144.863C112.265 144.863 112.921 145.024 113.48 145.346C114.043 145.668 114.479 146.134 114.787 146.745C115.099 147.356 115.253 148.097 115.248 148.968V155.914H112.677V149.366C112.677 148.637 112.488 148.066 112.109 147.654C111.735 147.242 111.217 147.036 110.554 147.036C110.104 147.036 109.704 147.136 109.354 147.335C109.008 147.529 108.736 147.81 108.537 148.18C108.343 148.549 108.246 148.996 108.246 149.522ZM121.001 156.134C120.31 156.134 119.687 156.011 119.133 155.765C118.584 155.514 118.148 155.145 117.827 154.657C117.509 154.169 117.351 153.568 117.351 152.853C117.351 152.237 117.464 151.728 117.692 151.326C117.919 150.924 118.229 150.602 118.622 150.36C119.015 150.119 119.458 149.936 119.95 149.813C120.447 149.685 120.961 149.593 121.491 149.536C122.131 149.47 122.649 149.411 123.047 149.359C123.444 149.302 123.733 149.217 123.913 149.103C124.098 148.985 124.19 148.802 124.19 148.556V148.513C124.19 147.978 124.032 147.564 123.714 147.271C123.397 146.977 122.94 146.83 122.344 146.83C121.714 146.83 121.214 146.968 120.845 147.242C120.48 147.517 120.234 147.841 120.106 148.215L117.706 147.874C117.895 147.211 118.208 146.657 118.643 146.212C119.079 145.763 119.612 145.426 120.241 145.204C120.871 144.977 121.567 144.863 122.329 144.863C122.855 144.863 123.378 144.924 123.899 145.048C124.42 145.171 124.896 145.374 125.327 145.658C125.757 145.938 126.103 146.319 126.363 146.802C126.629 147.285 126.761 147.888 126.761 148.613V155.914H124.29V154.415H124.204C124.048 154.719 123.828 155.003 123.544 155.268C123.265 155.528 122.912 155.739 122.486 155.9C122.064 156.056 121.569 156.134 121.001 156.134ZM121.669 154.245C122.185 154.245 122.632 154.143 123.011 153.94C123.39 153.731 123.681 153.457 123.885 153.116C124.093 152.775 124.197 152.403 124.197 152.001V150.715C124.117 150.781 123.979 150.843 123.785 150.9C123.596 150.957 123.383 151.006 123.146 151.049C122.909 151.092 122.675 151.129 122.443 151.163C122.211 151.196 122.01 151.224 121.839 151.248C121.456 151.3 121.113 151.385 120.809 151.504C120.506 151.622 120.267 151.788 120.092 152.001C119.917 152.209 119.829 152.479 119.829 152.81C119.829 153.284 120.002 153.641 120.348 153.883C120.693 154.124 121.134 154.245 121.669 154.245ZM129.46 155.914V141.369H132.031V146.809H132.138C132.27 146.544 132.457 146.262 132.699 145.964C132.94 145.661 133.267 145.403 133.679 145.19C134.091 144.972 134.616 144.863 135.256 144.863C136.098 144.863 136.858 145.078 137.535 145.509C138.217 145.935 138.757 146.567 139.155 147.406C139.557 148.239 139.758 149.262 139.758 150.474C139.758 151.672 139.562 152.69 139.169 153.528C138.776 154.366 138.241 155.005 137.564 155.445C136.887 155.886 136.12 156.106 135.263 156.106C134.638 156.106 134.119 156.002 133.707 155.793C133.295 155.585 132.964 155.334 132.713 155.04C132.467 154.742 132.275 154.46 132.138 154.195H131.988V155.914H129.46ZM131.981 150.46C131.981 151.165 132.081 151.783 132.28 152.313C132.483 152.844 132.774 153.258 133.153 153.556C133.537 153.85 134.001 153.996 134.545 153.996C135.113 153.996 135.589 153.845 135.973 153.542C136.356 153.234 136.645 152.815 136.839 152.285C137.038 151.75 137.138 151.141 137.138 150.46C137.138 149.782 137.041 149.181 136.846 148.656C136.652 148.13 136.363 147.718 135.98 147.42C135.596 147.121 135.118 146.972 134.545 146.972C133.996 146.972 133.53 147.117 133.146 147.406C132.763 147.694 132.471 148.099 132.273 148.62C132.078 149.141 131.981 149.754 131.981 150.46ZM144.515 141.369V155.914H141.944V141.369H144.515ZM151.988 156.127C150.895 156.127 149.95 155.9 149.155 155.445C148.364 154.986 147.756 154.337 147.329 153.499C146.903 152.656 146.69 151.665 146.69 150.523C146.69 149.401 146.903 148.416 147.329 147.569C147.76 146.717 148.362 146.054 149.133 145.58C149.905 145.102 150.812 144.863 151.854 144.863C152.526 144.863 153.16 144.972 153.757 145.19C154.358 145.403 154.889 145.734 155.348 146.184C155.812 146.634 156.176 147.207 156.442 147.903C156.707 148.594 156.839 149.418 156.839 150.374V151.163H147.898V149.43H154.375C154.37 148.937 154.264 148.499 154.055 148.116C153.847 147.728 153.556 147.422 153.182 147.2C152.812 146.977 152.381 146.866 151.889 146.866C151.363 146.866 150.902 146.994 150.504 147.249C150.106 147.5 149.796 147.832 149.574 148.244C149.356 148.651 149.245 149.098 149.24 149.586V151.099C149.24 151.733 149.356 152.278 149.588 152.732C149.82 153.182 150.144 153.528 150.561 153.769C150.978 154.006 151.465 154.124 152.024 154.124C152.398 154.124 152.737 154.072 153.04 153.968C153.343 153.859 153.605 153.701 153.828 153.492C154.05 153.284 154.219 153.026 154.332 152.718L156.733 152.988C156.581 153.622 156.292 154.176 155.866 154.65C155.445 155.119 154.905 155.483 154.247 155.744C153.589 155.999 152.836 156.127 151.988 156.127ZM163.45 143.577V141.369H175.055V143.577H170.559V155.914H167.945V143.577H163.45ZM180.355 156.127C179.29 156.127 178.366 155.893 177.585 155.424C176.804 154.955 176.198 154.299 175.767 153.457C175.341 152.614 175.128 151.629 175.128 150.502C175.128 149.375 175.341 148.388 175.767 147.54C176.198 146.693 176.804 146.035 177.585 145.566C178.366 145.097 179.29 144.863 180.355 144.863C181.42 144.863 182.344 145.097 183.125 145.566C183.906 146.035 184.51 146.693 184.936 147.54C185.367 148.388 185.582 149.375 185.582 150.502C185.582 151.629 185.367 152.614 184.936 153.457C184.51 154.299 183.906 154.955 183.125 155.424C182.344 155.893 181.42 156.127 180.355 156.127ZM180.369 154.067C180.947 154.067 181.43 153.909 181.818 153.592C182.206 153.27 182.495 152.839 182.684 152.299C182.879 151.759 182.976 151.158 182.976 150.495C182.976 149.827 182.879 149.224 182.684 148.684C182.495 148.139 182.206 147.706 181.818 147.384C181.43 147.062 180.947 146.901 180.369 146.901C179.777 146.901 179.285 147.062 178.892 147.384C178.504 147.706 178.212 148.139 178.018 148.684C177.829 149.224 177.734 149.827 177.734 150.495C177.734 151.158 177.829 151.759 178.018 152.299C178.212 152.839 178.504 153.27 178.892 153.592C179.285 153.909 179.777 154.067 180.369 154.067ZM197.768 155.914H192.839V141.369H197.867C199.311 141.369 200.552 141.66 201.589 142.242C202.631 142.82 203.431 143.651 203.99 144.735C204.548 145.819 204.828 147.117 204.828 148.627C204.828 150.142 204.546 151.444 203.982 152.533C203.424 153.622 202.616 154.458 201.561 155.04C200.509 155.623 199.245 155.914 197.768 155.914ZM195.474 153.634H197.64C198.653 153.634 199.499 153.45 200.176 153.08C200.853 152.706 201.362 152.15 201.703 151.411C202.044 150.668 202.214 149.74 202.214 148.627C202.214 147.514 202.044 146.591 201.703 145.857C201.362 145.119 200.857 144.567 200.19 144.202C199.527 143.833 198.703 143.648 197.718 143.648H195.474V153.634ZM211.976 156.127C210.911 156.127 209.987 155.893 209.206 155.424C208.425 154.955 207.819 154.299 207.388 153.457C206.962 152.614 206.749 151.629 206.749 150.502C206.749 149.375 206.962 148.388 207.388 147.54C207.819 146.693 208.425 146.035 209.206 145.566C209.987 145.097 210.911 144.863 211.976 144.863C213.041 144.863 213.965 145.097 214.746 145.566C215.527 146.035 216.131 146.693 216.557 147.54C216.988 148.388 217.203 149.375 217.203 150.502C217.203 151.629 216.988 152.614 216.557 153.457C216.131 154.299 215.527 154.955 214.746 155.424C213.965 155.893 213.041 156.127 211.976 156.127ZM211.99 154.067C212.568 154.067 213.051 153.909 213.439 153.592C213.827 153.27 214.116 152.839 214.306 152.299C214.5 151.759 214.597 151.158 214.597 150.495C214.597 149.827 214.5 149.224 214.306 148.684C214.116 148.139 213.827 147.706 213.439 147.384C213.051 147.062 212.568 146.901 211.99 146.901C211.398 146.901 210.906 147.062 210.513 147.384C210.125 147.706 209.834 148.139 209.639 148.684C209.45 149.224 209.355 149.827 209.355 150.495C209.355 151.158 209.45 151.759 209.639 152.299C209.834 152.839 210.125 153.27 210.513 153.592C210.906 153.909 211.398 154.067 211.99 154.067ZM221.324 155.914L218.242 145.005H220.863L222.78 152.675H222.88L224.84 145.005H227.432L229.393 152.633H229.499L231.388 145.005H234.016L230.927 155.914H228.249L226.204 148.542H226.055L224.009 155.914H221.324ZM238.382 149.522V155.914H235.811V145.005H238.269V146.859H238.396C238.647 146.248 239.048 145.763 239.597 145.403C240.151 145.043 240.835 144.863 241.649 144.863C242.402 144.863 243.058 145.024 243.617 145.346C244.18 145.668 244.616 146.134 244.923 146.745C245.236 147.356 245.39 148.097 245.385 148.968V155.914H242.814V149.366C242.814 148.637 242.625 148.066 242.246 147.654C241.872 147.242 241.353 147.036 240.691 147.036C240.241 147.036 239.841 147.136 239.49 147.335C239.145 147.529 238.872 147.81 238.673 148.18C238.479 148.549 238.382 148.996 238.382 149.522ZM250.57 141.369V155.914H247.999V141.369H250.57ZM257.972 156.127C256.907 156.127 255.983 155.893 255.202 155.424C254.421 154.955 253.815 154.299 253.384 153.457C252.958 152.614 252.745 151.629 252.745 150.502C252.745 149.375 252.958 148.388 253.384 147.54C253.815 146.693 254.421 146.035 255.202 145.566C255.983 145.097 256.907 144.863 257.972 144.863C259.037 144.863 259.961 145.097 260.742 145.566C261.523 146.035 262.127 146.693 262.553 147.54C262.984 148.388 263.199 149.375 263.199 150.502C263.199 151.629 262.984 152.614 262.553 153.457C262.127 154.299 261.523 154.955 260.742 155.424C259.961 155.893 259.037 156.127 257.972 156.127ZM257.986 154.067C258.564 154.067 259.047 153.909 259.435 153.592C259.823 153.27 260.112 152.839 260.302 152.299C260.496 151.759 260.593 151.158 260.593 150.495C260.593 149.827 260.496 149.224 260.302 148.684C260.112 148.139 259.823 147.706 259.435 147.384C259.047 147.062 258.564 146.901 257.986 146.901C257.394 146.901 256.902 147.062 256.509 147.384C256.121 147.706 255.83 148.139 255.635 148.684C255.446 149.224 255.351 149.827 255.351 150.495C255.351 151.158 255.446 151.759 255.635 152.299C255.83 152.839 256.121 153.27 256.509 153.592C256.902 153.909 257.394 154.067 257.986 154.067ZM268.521 156.134C267.829 156.134 267.207 156.011 266.653 155.765C266.104 155.514 265.668 155.145 265.346 154.657C265.029 154.169 264.87 153.568 264.87 152.853C264.87 152.237 264.984 151.728 265.211 151.326C265.438 150.924 265.749 150.602 266.142 150.36C266.535 150.119 266.977 149.936 267.47 149.813C267.967 149.685 268.481 149.593 269.011 149.536C269.65 149.47 270.169 149.411 270.566 149.359C270.964 149.302 271.253 149.217 271.433 149.103C271.617 148.985 271.71 148.802 271.71 148.556V148.513C271.71 147.978 271.551 147.564 271.234 147.271C270.917 146.977 270.46 146.83 269.863 146.83C269.233 146.83 268.734 146.968 268.365 147.242C268 147.517 267.754 147.841 267.626 148.215L265.225 147.874C265.415 147.211 265.727 146.657 266.163 146.212C266.598 145.763 267.131 145.426 267.761 145.204C268.391 144.977 269.087 144.863 269.849 144.863C270.374 144.863 270.898 144.924 271.419 145.048C271.939 145.171 272.415 145.374 272.846 145.658C273.277 145.938 273.623 146.319 273.883 146.802C274.148 147.285 274.281 147.888 274.281 148.613V155.914H271.809V154.415H271.724C271.568 154.719 271.347 155.003 271.063 155.268C270.784 155.528 270.431 155.739 270.005 155.9C269.584 156.056 269.089 156.134 268.521 156.134ZM269.188 154.245C269.704 154.245 270.152 154.143 270.531 153.94C270.91 153.731 271.201 153.457 271.404 153.116C271.613 152.775 271.717 152.403 271.717 152.001V150.715C271.636 150.781 271.499 150.843 271.305 150.9C271.115 150.957 270.902 151.006 270.666 151.049C270.429 151.092 270.195 151.129 269.963 151.163C269.731 151.196 269.529 151.224 269.359 151.248C268.975 151.3 268.632 151.385 268.329 151.504C268.026 151.622 267.787 151.788 267.612 152.001C267.436 152.209 267.349 152.479 267.349 152.81C267.349 153.284 267.522 153.641 267.867 153.883C268.213 154.124 268.653 154.245 269.188 154.245ZM280.914 156.106C280.057 156.106 279.29 155.886 278.613 155.445C277.936 155.005 277.401 154.366 277.008 153.528C276.615 152.69 276.419 151.672 276.419 150.474C276.419 149.262 276.617 148.239 277.015 147.406C277.418 146.567 277.96 145.935 278.642 145.509C279.323 145.078 280.083 144.863 280.921 144.863C281.561 144.863 282.086 144.972 282.498 145.19C282.91 145.403 283.237 145.661 283.478 145.964C283.72 146.262 283.907 146.544 284.039 146.809H284.146V141.369H286.724V155.914H284.195V154.195H284.039C283.907 154.46 283.715 154.742 283.464 155.04C283.213 155.334 282.882 155.585 282.47 155.793C282.058 156.002 281.539 156.106 280.914 156.106ZM281.632 153.996C282.176 153.996 282.64 153.85 283.024 153.556C283.407 153.258 283.698 152.844 283.897 152.313C284.096 151.783 284.195 151.165 284.195 150.46C284.195 149.754 284.096 149.141 283.897 148.62C283.703 148.099 283.414 147.694 283.031 147.406C282.652 147.117 282.186 146.972 281.632 146.972C281.059 146.972 280.58 147.121 280.197 147.42C279.813 147.718 279.525 148.13 279.33 148.656C279.136 149.181 279.039 149.782 279.039 150.46C279.039 151.141 279.136 151.75 279.33 152.285C279.529 152.815 279.82 153.234 280.204 153.542C280.592 153.845 281.068 153.996 281.632 153.996ZM292.61 141.369L292.376 151.638H290.089L289.861 141.369H292.61ZM291.232 156.07C290.801 156.07 290.432 155.919 290.124 155.616C289.821 155.313 289.67 154.943 289.67 154.508C289.67 154.082 289.821 153.717 290.124 153.414C290.432 153.111 290.801 152.96 291.232 152.96C291.653 152.96 292.018 153.111 292.326 153.414C292.638 153.717 292.795 154.082 292.795 154.508C292.795 154.797 292.721 155.059 292.574 155.296C292.432 155.533 292.243 155.722 292.006 155.864C291.774 156.002 291.516 156.07 291.232 156.07Z" fill="black"/>
                    <path d="M43.7173 182.914V172.732H47.1577C47.9564 172.732 48.6094 172.876 49.1165 173.165C49.6269 173.45 50.0047 173.836 50.25 174.323C50.4953 174.81 50.6179 175.354 50.6179 175.954C50.6179 176.554 50.4953 177.099 50.25 177.589C50.008 178.08 49.6335 178.471 49.1264 178.763C48.6193 179.051 47.9697 179.195 47.1776 179.195H44.7116V178.102H47.1378C47.6847 178.102 48.1238 178.007 48.4553 177.818C48.7867 177.629 49.027 177.374 49.1761 177.053C49.3286 176.728 49.4048 176.362 49.4048 175.954C49.4048 175.546 49.3286 175.182 49.1761 174.86C49.027 174.539 48.785 174.287 48.4503 174.104C48.1155 173.919 47.6714 173.826 47.1179 173.826H44.9503V182.914H43.7173ZM53.6183 172.732V182.914H52.445V172.732H53.6183ZM58.9689 183.073C58.2331 183.073 57.5984 182.911 57.0648 182.586C56.5345 182.258 56.1252 181.8 55.8368 181.214C55.5518 180.624 55.4093 179.938 55.4093 179.156C55.4093 178.373 55.5518 177.684 55.8368 177.087C56.1252 176.487 56.5262 176.02 57.04 175.685C57.557 175.347 58.1602 175.178 58.8496 175.178C59.2473 175.178 59.6401 175.245 60.0279 175.377C60.4157 175.51 60.7686 175.725 61.0868 176.023C61.405 176.318 61.6586 176.71 61.8475 177.197C62.0364 177.684 62.1309 178.284 62.1309 178.996V179.494H56.2445V178.479H60.9377C60.9377 178.049 60.8515 177.664 60.6792 177.326C60.5101 176.988 60.2682 176.721 59.9533 176.526C59.6417 176.33 59.2739 176.232 58.8496 176.232C58.3823 176.232 57.9779 176.348 57.6365 176.58C57.2985 176.809 57.0383 177.107 56.856 177.475C56.6737 177.843 56.5826 178.237 56.5826 178.658V179.335C56.5826 179.911 56.682 180.4 56.8809 180.801C57.083 181.199 57.3631 181.502 57.7211 181.711C58.079 181.916 58.495 182.019 58.9689 182.019C59.2772 182.019 59.5556 181.976 59.8042 181.89C60.056 181.8 60.2731 181.668 60.4554 181.492C60.6377 181.313 60.7786 181.091 60.878 180.826L62.0115 181.144C61.8922 181.529 61.6917 181.867 61.41 182.158C61.1283 182.447 60.7802 182.672 60.3659 182.835C59.9516 182.994 59.486 183.073 58.9689 183.073ZM66.1628 183.093C65.6789 183.093 65.2398 183.002 64.8453 182.82C64.4509 182.634 64.1377 182.367 63.9057 182.019C63.6737 181.668 63.5577 181.244 63.5577 180.746C63.5577 180.309 63.6439 179.954 63.8162 179.683C63.9886 179.407 64.2189 179.192 64.5073 179.036C64.7956 178.88 65.1138 178.764 65.4618 178.688C65.8132 178.609 66.1661 178.546 66.5208 178.499C66.9848 178.44 67.361 178.395 67.6493 178.365C67.941 178.332 68.1531 178.277 68.2857 178.201C68.4216 178.125 68.4895 177.992 68.4895 177.803V177.763C68.4895 177.273 68.3553 176.892 68.0868 176.62C67.8217 176.348 67.419 176.212 66.8787 176.212C66.3186 176.212 65.8794 176.335 65.5613 176.58C65.2431 176.826 65.0194 177.087 64.8901 177.366L63.7765 176.968C63.9753 176.504 64.2405 176.143 64.5719 175.884C64.9067 175.622 65.2712 175.44 65.6657 175.337C66.0634 175.231 66.4545 175.178 66.839 175.178C67.0842 175.178 67.3659 175.208 67.6841 175.268C68.0056 175.324 68.3155 175.442 68.6138 175.621C68.9154 175.8 69.1657 176.07 69.3645 176.431C69.5634 176.792 69.6628 177.276 69.6628 177.883V182.914H68.4895V181.88H68.4299C68.3503 182.046 68.2177 182.223 68.0321 182.412C67.8465 182.601 67.5996 182.762 67.2914 182.894C66.9831 183.027 66.6069 183.093 66.1628 183.093ZM66.3418 182.039C66.8058 182.039 67.1969 181.948 67.5151 181.766C67.8366 181.583 68.0785 181.348 68.2409 181.06C68.4067 180.771 68.4895 180.468 68.4895 180.15V179.076C68.4398 179.136 68.3304 179.19 68.1614 179.24C67.9957 179.286 67.8034 179.328 67.5847 179.364C67.3693 179.397 67.1588 179.427 66.9533 179.454C66.7511 179.477 66.5871 179.497 66.4611 179.513C66.1562 179.553 65.8712 179.618 65.606 179.707C65.3442 179.794 65.132 179.924 64.9696 180.1C64.8105 180.272 64.731 180.508 64.731 180.806C64.731 181.214 64.8818 181.522 65.1834 181.731C65.4883 181.936 65.8745 182.039 66.3418 182.039ZM77.2134 176.988L76.1594 177.286C76.0932 177.111 75.9954 176.94 75.8661 176.774C75.7402 176.605 75.5678 176.466 75.3491 176.357C75.1303 176.247 74.8503 176.192 74.5089 176.192C74.0415 176.192 73.6521 176.3 73.3406 176.516C73.0323 176.728 72.8782 176.998 72.8782 177.326C72.8782 177.618 72.9843 177.848 73.1964 178.017C73.4085 178.186 73.7399 178.327 74.1907 178.44L75.3242 178.718C76.007 178.884 76.5157 179.137 76.8505 179.479C77.1853 179.817 77.3526 180.253 77.3526 180.786C77.3526 181.224 77.2267 181.615 76.9748 181.96C76.7262 182.304 76.3782 182.576 75.9308 182.775C75.4833 182.974 74.9629 183.073 74.3697 183.073C73.5908 183.073 72.9461 182.904 72.4357 182.566C71.9253 182.228 71.6022 181.734 71.4663 181.085L72.5799 180.806C72.686 181.217 72.8865 181.525 73.1815 181.731C73.4798 181.936 73.8692 182.039 74.3498 182.039C74.8967 182.039 75.3308 181.923 75.6523 181.691C75.9772 181.456 76.1396 181.174 76.1396 180.846C76.1396 180.581 76.0468 180.359 75.8612 180.18C75.6755 179.997 75.3905 179.862 75.006 179.772L73.7333 179.474C73.034 179.308 72.5202 179.051 72.1921 178.703C71.8673 178.352 71.7049 177.913 71.7049 177.386C71.7049 176.955 71.8259 176.574 72.0678 176.242C72.3131 175.911 72.6462 175.651 73.0671 175.462C73.4914 175.273 73.9719 175.178 74.5089 175.178C75.2646 175.178 75.8578 175.344 76.2887 175.675C76.7229 176.007 77.0311 176.444 77.2134 176.988ZM82.3205 183.073C81.5847 183.073 80.95 182.911 80.4164 182.586C79.8861 182.258 79.4767 181.8 79.1884 181.214C78.9033 180.624 78.7608 179.938 78.7608 179.156C78.7608 178.373 78.9033 177.684 79.1884 177.087C79.4767 176.487 79.8778 176.02 80.3915 175.685C80.9086 175.347 81.5118 175.178 82.2012 175.178C82.5989 175.178 82.9917 175.245 83.3794 175.377C83.7672 175.51 84.1202 175.725 84.4384 176.023C84.7566 176.318 85.0101 176.71 85.199 177.197C85.388 177.684 85.4824 178.284 85.4824 178.996V179.494H79.5961V178.479H84.2892C84.2892 178.049 84.2031 177.664 84.0307 177.326C83.8617 176.988 83.6197 176.721 83.3049 176.526C82.9933 176.33 82.6254 176.232 82.2012 176.232C81.7338 176.232 81.3295 176.348 80.9881 176.58C80.65 176.809 80.3899 177.107 80.2076 177.475C80.0253 177.843 79.9341 178.237 79.9341 178.658V179.335C79.9341 179.911 80.0336 180.4 80.2324 180.801C80.4346 181.199 80.7147 181.502 81.0726 181.711C81.4306 181.916 81.8465 182.019 82.3205 182.019C82.6287 182.019 82.9071 181.976 83.1557 181.89C83.4076 181.8 83.6247 181.668 83.807 181.492C83.9893 181.313 84.1301 181.091 84.2296 180.826L85.3631 181.144C85.2438 181.529 85.0433 181.867 84.7615 182.158C84.4798 182.447 84.1318 182.672 83.7175 182.835C83.3032 182.994 82.8375 183.073 82.3205 183.073ZM96.6138 176.988L95.5598 177.286C95.4935 177.111 95.3958 176.94 95.2665 176.774C95.1406 176.605 94.9682 176.466 94.7495 176.357C94.5307 176.247 94.2507 176.192 93.9093 176.192C93.4419 176.192 93.0525 176.3 92.7409 176.516C92.4327 176.728 92.2786 176.998 92.2786 177.326C92.2786 177.618 92.3846 177.848 92.5968 178.017C92.8089 178.186 93.1403 178.327 93.5911 178.44L94.7246 178.718C95.4074 178.884 95.9161 179.137 96.2509 179.479C96.5856 179.817 96.753 180.253 96.753 180.786C96.753 181.224 96.6271 181.615 96.3752 181.96C96.1266 182.304 95.7786 182.576 95.3311 182.775C94.8837 182.974 94.3633 183.073 93.7701 183.073C92.9912 183.073 92.3465 182.904 91.8361 182.566C91.3257 182.228 91.0025 181.734 90.8667 181.085L91.9803 180.806C92.0864 181.217 92.2869 181.525 92.5819 181.731C92.8801 181.936 93.2696 182.039 93.7502 182.039C94.2971 182.039 94.7312 181.923 95.0527 181.691C95.3775 181.456 95.54 181.174 95.54 180.846C95.54 180.581 95.4471 180.359 95.2615 180.18C95.0759 179.997 94.7909 179.862 94.4064 179.772L93.1337 179.474C92.4344 179.308 91.9206 179.051 91.5925 178.703C91.2677 178.352 91.1053 177.913 91.1053 177.386C91.1053 176.955 91.2263 176.574 91.4682 176.242C91.7135 175.911 92.0466 175.651 92.4675 175.462C92.8917 175.273 93.3723 175.178 93.9093 175.178C94.665 175.178 95.2582 175.344 95.6891 175.675C96.1233 176.007 96.4315 176.444 96.6138 176.988ZM101.721 183.073C100.985 183.073 100.35 182.911 99.8168 182.586C99.2865 182.258 98.8771 181.8 98.5888 181.214C98.3037 180.624 98.1612 179.938 98.1612 179.156C98.1612 178.373 98.3037 177.684 98.5888 177.087C98.8771 176.487 99.2782 176.02 99.7919 175.685C100.309 175.347 100.912 175.178 101.602 175.178C101.999 175.178 102.392 175.245 102.78 175.377C103.168 175.51 103.521 175.725 103.839 176.023C104.157 176.318 104.411 176.71 104.599 177.197C104.788 177.684 104.883 178.284 104.883 178.996V179.494H98.9964V178.479H103.69C103.69 178.049 103.603 177.664 103.431 177.326C103.262 176.988 103.02 176.721 102.705 176.526C102.394 176.33 102.026 176.232 101.602 176.232C101.134 176.232 100.73 176.348 100.388 176.58C100.05 176.809 99.7902 177.107 99.608 177.475C99.4257 177.843 99.3345 178.237 99.3345 178.658V179.335C99.3345 179.911 99.4339 180.4 99.6328 180.801C99.835 181.199 100.115 181.502 100.473 181.711C100.831 181.916 101.247 182.019 101.721 182.019C102.029 182.019 102.308 181.976 102.556 181.89C102.808 181.8 103.025 181.668 103.207 181.492C103.39 181.313 103.531 181.091 103.63 180.826L104.763 181.144C104.644 181.529 104.444 181.867 104.162 182.158C103.88 182.447 103.532 182.672 103.118 182.835C102.704 182.994 102.238 183.073 101.721 183.073ZM107.841 172.732V182.914H106.668V172.732H107.841ZM113.192 183.073C112.456 183.073 111.821 182.911 111.287 182.586C110.757 182.258 110.348 181.8 110.059 181.214C109.774 180.624 109.632 179.938 109.632 179.156C109.632 178.373 109.774 177.684 110.059 177.087C110.348 176.487 110.749 176.02 111.263 175.685C111.78 175.347 112.383 175.178 113.072 175.178C113.47 175.178 113.863 175.245 114.251 175.377C114.638 175.51 114.991 175.725 115.309 176.023C115.628 176.318 115.881 176.71 116.07 177.197C116.259 177.684 116.354 178.284 116.354 178.996V179.494H110.467V178.479H115.16C115.16 178.049 115.074 177.664 114.902 177.326C114.733 176.988 114.491 176.721 114.176 176.526C113.864 176.33 113.497 176.232 113.072 176.232C112.605 176.232 112.201 176.348 111.859 176.58C111.521 176.809 111.261 177.107 111.079 177.475C110.896 177.843 110.805 178.237 110.805 178.658V179.335C110.805 179.911 110.905 180.4 111.104 180.801C111.306 181.199 111.586 181.502 111.944 181.711C112.302 181.916 112.718 182.019 113.192 182.019C113.5 182.019 113.778 181.976 114.027 181.89C114.279 181.8 114.496 181.668 114.678 181.492C114.86 181.313 115.001 181.091 115.101 180.826L116.234 181.144C116.115 181.529 115.914 181.867 115.633 182.158C115.351 182.447 115.003 182.672 114.589 182.835C114.174 182.994 113.709 183.073 113.192 183.073ZM121.241 183.073C120.525 183.073 119.908 182.904 119.391 182.566C118.874 182.228 118.476 181.762 118.198 181.169C117.92 180.576 117.78 179.898 117.78 179.136C117.78 178.36 117.923 177.676 118.208 177.082C118.496 176.486 118.897 176.02 119.411 175.685C119.928 175.347 120.531 175.178 121.221 175.178C121.758 175.178 122.242 175.278 122.672 175.477C123.103 175.675 123.456 175.954 123.731 176.312C124.006 176.67 124.177 177.087 124.243 177.565H123.07C122.981 177.217 122.782 176.908 122.474 176.64C122.169 176.368 121.758 176.232 121.241 176.232C120.783 176.232 120.382 176.352 120.037 176.59C119.696 176.826 119.429 177.159 119.237 177.589C119.048 178.017 118.954 178.519 118.954 179.096C118.954 179.686 119.046 180.2 119.232 180.637C119.421 181.075 119.686 181.414 120.028 181.656C120.372 181.898 120.777 182.019 121.241 182.019C121.546 182.019 121.822 181.966 122.071 181.86C122.319 181.754 122.53 181.602 122.702 181.403C122.875 181.204 122.997 180.965 123.07 180.687H124.243C124.177 181.138 124.013 181.544 123.751 181.905C123.493 182.263 123.15 182.548 122.722 182.76C122.298 182.969 121.804 183.073 121.241 183.073ZM129.28 175.278V176.272H125.322V175.278H129.28ZM126.476 173.448H127.649V180.727C127.649 181.058 127.697 181.307 127.793 181.472C127.893 181.635 128.019 181.744 128.171 181.8C128.327 181.853 128.491 181.88 128.663 181.88C128.792 181.88 128.898 181.873 128.981 181.86C129.064 181.844 129.131 181.83 129.18 181.82L129.419 182.874C129.339 182.904 129.228 182.934 129.086 182.964C128.943 182.997 128.763 183.013 128.544 183.013C128.212 183.013 127.888 182.942 127.569 182.8C127.255 182.657 126.993 182.44 126.784 182.148C126.578 181.857 126.476 181.489 126.476 181.045V173.448ZM138.303 175.278V176.272H134.346V175.278H138.303ZM135.499 173.448H136.672V180.727C136.672 181.058 136.72 181.307 136.817 181.472C136.916 181.635 137.042 181.744 137.194 181.8C137.35 181.853 137.514 181.88 137.687 181.88C137.816 181.88 137.922 181.873 138.005 181.86C138.088 181.844 138.154 181.83 138.204 181.82L138.442 182.874C138.363 182.904 138.252 182.934 138.109 182.964C137.967 182.997 137.786 183.013 137.567 183.013C137.236 183.013 136.911 182.942 136.593 182.8C136.278 182.657 136.016 182.44 135.807 182.148C135.602 181.857 135.499 181.489 135.499 181.045V173.448ZM141.405 178.32V182.914H140.232V172.732H141.405V176.471H141.505C141.684 176.076 141.952 175.763 142.31 175.531C142.671 175.296 143.152 175.178 143.752 175.178C144.272 175.178 144.728 175.283 145.119 175.491C145.51 175.697 145.814 176.013 146.029 176.441C146.248 176.865 146.357 177.406 146.357 178.062V182.914H145.184V178.141C145.184 177.535 145.026 177.066 144.711 176.734C144.4 176.4 143.967 176.232 143.414 176.232C143.029 176.232 142.685 176.313 142.38 176.476C142.078 176.638 141.84 176.875 141.664 177.187C141.492 177.498 141.405 177.876 141.405 178.32ZM151.705 183.073C150.969 183.073 150.335 182.911 149.801 182.586C149.271 182.258 148.862 181.8 148.573 181.214C148.288 180.624 148.146 179.938 148.146 179.156C148.146 178.373 148.288 177.684 148.573 177.087C148.862 176.487 149.263 176.02 149.776 175.685C150.293 175.347 150.897 175.178 151.586 175.178C151.984 175.178 152.376 175.245 152.764 175.377C153.152 175.51 153.505 175.725 153.823 176.023C154.141 176.318 154.395 176.71 154.584 177.197C154.773 177.684 154.867 178.284 154.867 178.996V179.494H148.981V178.479H153.674C153.674 178.049 153.588 177.664 153.415 177.326C153.246 176.988 153.004 176.721 152.69 176.526C152.378 176.33 152.01 176.232 151.586 176.232C151.119 176.232 150.714 176.348 150.373 176.58C150.035 176.809 149.775 177.107 149.592 177.475C149.41 177.843 149.319 178.237 149.319 178.658V179.335C149.319 179.911 149.418 180.4 149.617 180.801C149.819 181.199 150.099 181.502 150.457 181.711C150.815 181.916 151.231 182.019 151.705 182.019C152.013 182.019 152.292 181.976 152.54 181.89C152.792 181.8 153.009 181.668 153.192 181.492C153.374 181.313 153.515 181.091 153.614 180.826L154.748 181.144C154.629 181.529 154.428 181.867 154.146 182.158C153.865 182.447 153.517 182.672 153.102 182.835C152.688 182.994 152.222 183.073 151.705 183.073ZM163.473 183.073C162.837 183.073 162.275 182.912 161.788 182.591C161.3 182.266 160.919 181.809 160.644 181.219C160.369 180.625 160.232 179.924 160.232 179.116C160.232 178.314 160.369 177.618 160.644 177.028C160.919 176.438 161.302 175.982 161.793 175.661C162.283 175.339 162.85 175.178 163.493 175.178C163.99 175.178 164.383 175.261 164.671 175.427C164.963 175.589 165.185 175.775 165.337 175.984C165.493 176.189 165.614 176.358 165.7 176.491H165.8V172.732H166.973V182.914H165.839V181.741H165.7C165.614 181.88 165.491 182.056 165.332 182.268C165.173 182.477 164.946 182.664 164.651 182.83C164.356 182.992 163.964 183.073 163.473 183.073ZM163.632 182.019C164.103 182.019 164.5 181.897 164.825 181.651C165.15 181.403 165.397 181.06 165.566 180.622C165.735 180.181 165.82 179.673 165.82 179.096C165.82 178.526 165.737 178.027 165.571 177.599C165.405 177.169 165.16 176.834 164.835 176.595C164.51 176.353 164.109 176.232 163.632 176.232C163.135 176.232 162.721 176.36 162.389 176.615C162.061 176.867 161.814 177.21 161.648 177.644C161.486 178.075 161.405 178.559 161.405 179.096C161.405 179.639 161.488 180.133 161.653 180.577C161.822 181.018 162.071 181.37 162.399 181.631C162.731 181.89 163.142 182.019 163.632 182.019ZM171.532 183.093C171.048 183.093 170.609 183.002 170.214 182.82C169.82 182.634 169.507 182.367 169.275 182.019C169.043 181.668 168.927 181.244 168.927 180.746C168.927 180.309 169.013 179.954 169.185 179.683C169.358 179.407 169.588 179.192 169.876 179.036C170.165 178.88 170.483 178.764 170.831 178.688C171.182 178.609 171.535 178.546 171.89 178.499C172.354 178.44 172.73 178.395 173.018 178.365C173.31 178.332 173.522 178.277 173.655 178.201C173.791 178.125 173.859 177.992 173.859 177.803V177.763C173.859 177.273 173.724 176.892 173.456 176.62C173.191 176.348 172.788 176.212 172.248 176.212C171.688 176.212 171.249 176.335 170.93 176.58C170.612 176.826 170.388 177.087 170.259 177.366L169.146 176.968C169.344 176.504 169.61 176.143 169.941 175.884C170.276 175.622 170.64 175.44 171.035 175.337C171.433 175.231 171.824 175.178 172.208 175.178C172.453 175.178 172.735 175.208 173.053 175.268C173.375 175.324 173.685 175.442 173.983 175.621C174.285 175.8 174.535 176.07 174.734 176.431C174.933 176.792 175.032 177.276 175.032 177.883V182.914H173.859V181.88H173.799C173.719 182.046 173.587 182.223 173.401 182.412C173.216 182.601 172.969 182.762 172.661 182.894C172.352 183.027 171.976 183.093 171.532 183.093ZM171.711 182.039C172.175 182.039 172.566 181.948 172.884 181.766C173.206 181.583 173.448 181.348 173.61 181.06C173.776 180.771 173.859 180.468 173.859 180.15V179.076C173.809 179.136 173.7 179.19 173.531 179.24C173.365 179.286 173.173 179.328 172.954 179.364C172.738 179.397 172.528 179.427 172.322 179.454C172.12 179.477 171.956 179.497 171.83 179.513C171.525 179.553 171.24 179.618 170.975 179.707C170.713 179.794 170.501 179.924 170.339 180.1C170.18 180.272 170.1 180.508 170.1 180.806C170.1 181.214 170.251 181.522 170.553 181.731C170.857 181.936 171.244 182.039 171.711 182.039ZM180.494 175.278V176.272H176.537V175.278H180.494ZM177.691 173.448H178.864V180.727C178.864 181.058 178.912 181.307 179.008 181.472C179.107 181.635 179.233 181.744 179.386 181.8C179.542 181.853 179.706 181.88 179.878 181.88C180.007 181.88 180.113 181.873 180.196 181.86C180.279 181.844 180.345 181.83 180.395 181.82L180.634 182.874C180.554 182.904 180.443 182.934 180.301 182.964C180.158 182.997 179.977 183.013 179.759 183.013C179.427 183.013 179.102 182.942 178.784 182.8C178.469 182.657 178.208 182.44 177.999 182.148C177.793 181.857 177.691 181.489 177.691 181.045V173.448ZM185.379 183.073C184.643 183.073 184.009 182.911 183.475 182.586C182.945 182.258 182.535 181.8 182.247 181.214C181.962 180.624 181.819 179.938 181.819 179.156C181.819 178.373 181.962 177.684 182.247 177.087C182.535 176.487 182.936 176.02 183.45 175.685C183.967 175.347 184.57 175.178 185.26 175.178C185.657 175.178 186.05 175.245 186.438 175.377C186.826 175.51 187.179 175.725 187.497 176.023C187.815 176.318 188.069 176.71 188.258 177.197C188.447 177.684 188.541 178.284 188.541 178.996V179.494H182.655V178.479H187.348C187.348 178.049 187.262 177.664 187.089 177.326C186.92 176.988 186.678 176.721 186.363 176.526C186.052 176.33 185.684 176.232 185.26 176.232C184.792 176.232 184.388 176.348 184.047 176.58C183.709 176.809 183.448 177.107 183.266 177.475C183.084 177.843 182.993 178.237 182.993 178.658V179.335C182.993 179.911 183.092 180.4 183.291 180.801C183.493 181.199 183.773 181.502 184.131 181.711C184.489 181.916 184.905 182.019 185.379 182.019C185.687 182.019 185.966 181.976 186.214 181.89C186.466 181.8 186.683 181.668 186.866 181.492C187.048 181.313 187.189 181.091 187.288 180.826L188.422 181.144C188.302 181.529 188.102 181.867 187.82 182.158C187.538 182.447 187.19 182.672 186.776 182.835C186.362 182.994 185.896 183.073 185.379 183.073ZM195.735 176.988L194.681 177.286C194.615 177.111 194.517 176.94 194.388 176.774C194.262 176.605 194.089 176.466 193.871 176.357C193.652 176.247 193.372 176.192 193.03 176.192C192.563 176.192 192.174 176.3 191.862 176.516C191.554 176.728 191.4 176.998 191.4 177.326C191.4 177.618 191.506 177.848 191.718 178.017C191.93 178.186 192.261 178.327 192.712 178.44L193.846 178.718C194.528 178.884 195.037 179.137 195.372 179.479C195.707 179.817 195.874 180.253 195.874 180.786C195.874 181.224 195.748 181.615 195.496 181.96C195.248 182.304 194.9 182.576 194.452 182.775C194.005 182.974 193.484 183.073 192.891 183.073C192.112 183.073 191.468 182.904 190.957 182.566C190.447 182.228 190.124 181.734 189.988 181.085L191.101 180.806C191.207 181.217 191.408 181.525 191.703 181.731C192.001 181.936 192.391 182.039 192.871 182.039C193.418 182.039 193.852 181.923 194.174 181.691C194.499 181.456 194.661 181.174 194.661 180.846C194.661 180.581 194.568 180.359 194.383 180.18C194.197 179.997 193.912 179.862 193.528 179.772L192.255 179.474C191.555 179.308 191.042 179.051 190.714 178.703C190.389 178.352 190.226 177.913 190.226 177.386C190.226 176.955 190.347 176.574 190.589 176.242C190.835 175.911 191.168 175.651 191.589 175.462C192.013 175.273 192.493 175.178 193.03 175.178C193.786 175.178 194.379 175.344 194.81 175.675C195.244 176.007 195.553 176.444 195.735 176.988ZM204.899 175.278V176.272H200.941V175.278H204.899ZM202.095 173.448H203.268V180.727C203.268 181.058 203.316 181.307 203.412 181.472C203.512 181.635 203.638 181.744 203.79 181.8C203.946 181.853 204.11 181.88 204.282 181.88C204.412 181.88 204.518 181.873 204.6 181.86C204.683 181.844 204.75 181.83 204.799 181.82L205.038 182.874C204.958 182.904 204.847 182.934 204.705 182.964C204.562 182.997 204.382 183.013 204.163 183.013C203.832 183.013 203.507 182.942 203.189 182.8C202.874 182.657 202.612 182.44 202.403 182.148C202.198 181.857 202.095 181.489 202.095 181.045V173.448ZM209.684 183.073C208.995 183.073 208.39 182.909 207.869 182.581C207.352 182.253 206.948 181.794 206.656 181.204C206.368 180.614 206.224 179.924 206.224 179.136C206.224 178.34 206.368 177.646 206.656 177.053C206.948 176.459 207.352 175.999 207.869 175.67C208.39 175.342 208.995 175.178 209.684 175.178C210.373 175.178 210.977 175.342 211.494 175.67C212.014 175.999 212.418 176.459 212.707 177.053C212.998 177.646 213.144 178.34 213.144 179.136C213.144 179.924 212.998 180.614 212.707 181.204C212.418 181.794 212.014 182.253 211.494 182.581C210.977 182.909 210.373 183.073 209.684 183.073ZM209.684 182.019C210.208 182.019 210.638 181.885 210.977 181.616C211.315 181.348 211.565 180.995 211.727 180.558C211.89 180.12 211.971 179.646 211.971 179.136C211.971 178.625 211.89 178.15 211.727 177.709C211.565 177.268 211.315 176.912 210.977 176.64C210.638 176.368 210.208 176.232 209.684 176.232C209.16 176.232 208.729 176.368 208.391 176.64C208.053 176.912 207.803 177.268 207.641 177.709C207.478 178.15 207.397 178.625 207.397 179.136C207.397 179.646 207.478 180.12 207.641 180.558C207.803 180.995 208.053 181.348 208.391 181.616C208.729 181.885 209.16 182.019 209.684 182.019ZM221.756 183.073C221.12 183.073 220.558 182.912 220.071 182.591C219.584 182.266 219.202 181.809 218.927 181.219C218.652 180.625 218.515 179.924 218.515 179.116C218.515 178.314 218.652 177.618 218.927 177.028C219.202 176.438 219.585 175.982 220.076 175.661C220.566 175.339 221.133 175.178 221.776 175.178C222.273 175.178 222.666 175.261 222.954 175.427C223.246 175.589 223.468 175.775 223.621 175.984C223.776 176.189 223.897 176.358 223.983 176.491H224.083V172.732H225.256V182.914H224.123V181.741H223.983C223.897 181.88 223.775 182.056 223.616 182.268C223.456 182.477 223.229 182.664 222.934 182.83C222.64 182.992 222.247 183.073 221.756 183.073ZM221.915 182.019C222.386 182.019 222.784 181.897 223.108 181.651C223.433 181.403 223.68 181.06 223.849 180.622C224.018 180.181 224.103 179.673 224.103 179.096C224.103 178.526 224.02 178.027 223.854 177.599C223.689 177.169 223.443 176.834 223.118 176.595C222.794 176.353 222.393 176.232 221.915 176.232C221.418 176.232 221.004 176.36 220.672 176.615C220.344 176.867 220.097 177.21 219.932 177.644C219.769 178.075 219.688 178.559 219.688 179.096C219.688 179.639 219.771 180.133 219.937 180.577C220.106 181.018 220.354 181.37 220.682 181.631C221.014 181.89 221.425 182.019 221.915 182.019ZM230.67 183.073C229.981 183.073 229.376 182.909 228.856 182.581C228.339 182.253 227.934 181.794 227.643 181.204C227.354 180.614 227.21 179.924 227.21 179.136C227.21 178.34 227.354 177.646 227.643 177.053C227.934 176.459 228.339 175.999 228.856 175.67C229.376 175.342 229.981 175.178 230.67 175.178C231.36 175.178 231.963 175.342 232.48 175.67C233 175.999 233.405 176.459 233.693 177.053C233.985 177.646 234.131 178.34 234.131 179.136C234.131 179.924 233.985 180.614 233.693 181.204C233.405 181.794 233 182.253 232.48 182.581C231.963 182.909 231.36 183.073 230.67 183.073ZM230.67 182.019C231.194 182.019 231.625 181.885 231.963 181.616C232.301 181.348 232.551 180.995 232.714 180.558C232.876 180.12 232.957 179.646 232.957 179.136C232.957 178.625 232.876 178.15 232.714 177.709C232.551 177.268 232.301 176.912 231.963 176.64C231.625 176.368 231.194 176.232 230.67 176.232C230.147 176.232 229.716 176.368 229.378 176.64C229.04 176.912 228.789 177.268 228.627 177.709C228.465 178.15 228.383 178.625 228.383 179.136C228.383 179.646 228.465 180.12 228.627 180.558C228.789 180.995 229.04 181.348 229.378 181.616C229.716 181.885 230.147 182.019 230.67 182.019ZM237.392 182.914L235.065 175.278H236.298L237.949 181.124H238.028L239.659 175.278H240.912L242.523 181.104H242.602L244.253 175.278H245.486L243.159 182.914H242.006L240.335 177.048H240.216L238.545 182.914H237.392ZM248.21 178.32V182.914H247.037V175.278H248.17V176.471H248.27C248.449 176.083 248.72 175.772 249.085 175.536C249.45 175.298 249.92 175.178 250.497 175.178C251.014 175.178 251.466 175.284 251.854 175.496C252.242 175.705 252.544 176.023 252.759 176.451C252.974 176.875 253.082 177.412 253.082 178.062V182.914H251.909V178.141C251.909 177.541 251.753 177.074 251.442 176.739C251.13 176.401 250.702 176.232 250.159 176.232C249.784 176.232 249.45 176.313 249.155 176.476C248.863 176.638 248.633 176.875 248.464 177.187C248.295 177.498 248.21 177.876 248.21 178.32ZM256.4 172.732V182.914H255.226V172.732H256.4ZM261.651 183.073C260.961 183.073 260.356 182.909 259.836 182.581C259.319 182.253 258.915 181.794 258.623 181.204C258.335 180.614 258.191 179.924 258.191 179.136C258.191 178.34 258.335 177.646 258.623 177.053C258.915 176.459 259.319 175.999 259.836 175.67C260.356 175.342 260.961 175.178 261.651 175.178C262.34 175.178 262.943 175.342 263.46 175.67C263.981 175.999 264.385 176.459 264.673 177.053C264.965 177.646 265.111 178.34 265.111 179.136C265.111 179.924 264.965 180.614 264.673 181.204C264.385 181.794 263.981 182.253 263.46 182.581C262.943 182.909 262.34 183.073 261.651 183.073ZM261.651 182.019C262.174 182.019 262.605 181.885 262.943 181.616C263.281 181.348 263.532 180.995 263.694 180.558C263.856 180.12 263.938 179.646 263.938 179.136C263.938 178.625 263.856 178.15 263.694 177.709C263.532 177.268 263.281 176.912 262.943 176.64C262.605 176.368 262.174 176.232 261.651 176.232C261.127 176.232 260.696 176.368 260.358 176.64C260.02 176.912 259.77 177.268 259.607 177.709C259.445 178.15 259.364 178.625 259.364 179.136C259.364 179.646 259.445 180.12 259.607 180.558C259.77 180.995 260.02 181.348 260.358 181.616C260.696 181.885 261.127 182.019 261.651 182.019ZM269.149 183.093C268.665 183.093 268.226 183.002 267.832 182.82C267.437 182.634 267.124 182.367 266.892 182.019C266.66 181.668 266.544 181.244 266.544 180.746C266.544 180.309 266.63 179.954 266.803 179.683C266.975 179.407 267.205 179.192 267.494 179.036C267.782 178.88 268.1 178.764 268.448 178.688C268.799 178.609 269.152 178.546 269.507 178.499C269.971 178.44 270.347 178.395 270.636 178.365C270.927 178.332 271.139 178.277 271.272 178.201C271.408 178.125 271.476 177.992 271.476 177.803V177.763C271.476 177.273 271.342 176.892 271.073 176.62C270.808 176.348 270.405 176.212 269.865 176.212C269.305 176.212 268.866 176.335 268.548 176.58C268.229 176.826 268.006 177.087 267.876 177.366L266.763 176.968C266.962 176.504 267.227 176.143 267.558 175.884C267.893 175.622 268.258 175.44 268.652 175.337C269.05 175.231 269.441 175.178 269.825 175.178C270.071 175.178 270.352 175.208 270.67 175.268C270.992 175.324 271.302 175.442 271.6 175.621C271.902 175.8 272.152 176.07 272.351 176.431C272.55 176.792 272.649 177.276 272.649 177.883V182.914H271.476V181.88H271.416C271.337 182.046 271.204 182.223 271.018 182.412C270.833 182.601 270.586 182.762 270.278 182.894C269.969 183.027 269.593 183.093 269.149 183.093ZM269.328 182.039C269.792 182.039 270.183 181.948 270.501 181.766C270.823 181.583 271.065 181.348 271.227 181.06C271.393 180.771 271.476 180.468 271.476 180.15V179.076C271.426 179.136 271.317 179.19 271.148 179.24C270.982 179.286 270.79 179.328 270.571 179.364C270.356 179.397 270.145 179.427 269.94 179.454C269.737 179.477 269.573 179.497 269.447 179.513C269.143 179.553 268.857 179.618 268.592 179.707C268.33 179.794 268.118 179.924 267.956 180.1C267.797 180.272 267.717 180.508 267.717 180.806C267.717 181.214 267.868 181.522 268.17 181.731C268.475 181.936 268.861 182.039 269.328 182.039ZM277.674 183.073C277.038 183.073 276.476 182.912 275.989 182.591C275.502 182.266 275.12 181.809 274.845 181.219C274.57 180.625 274.433 179.924 274.433 179.116C274.433 178.314 274.57 177.618 274.845 177.028C275.12 176.438 275.503 175.982 275.994 175.661C276.484 175.339 277.051 175.178 277.694 175.178C278.191 175.178 278.584 175.261 278.872 175.427C279.164 175.589 279.386 175.775 279.539 175.984C279.694 176.189 279.815 176.358 279.901 176.491H280.001V172.732H281.174V182.914H280.041V181.741H279.901C279.815 181.88 279.693 182.056 279.534 182.268C279.374 182.477 279.147 182.664 278.852 182.83C278.557 182.992 278.165 183.073 277.674 183.073ZM277.833 182.019C278.304 182.019 278.702 181.897 279.026 181.651C279.351 181.403 279.598 181.06 279.767 180.622C279.936 180.181 280.021 179.673 280.021 179.096C280.021 178.526 279.938 178.027 279.772 177.599C279.606 177.169 279.361 176.834 279.036 176.595C278.712 176.353 278.311 176.232 277.833 176.232C277.336 176.232 276.922 176.36 276.59 176.615C276.262 176.867 276.015 177.21 275.85 177.644C275.687 178.075 275.606 178.559 275.606 179.096C275.606 179.639 275.689 180.133 275.855 180.577C276.024 181.018 276.272 181.37 276.6 181.631C276.932 181.89 277.343 182.019 277.833 182.019ZM290.744 175.278V176.272H286.787V175.278H290.744ZM287.941 173.448H289.114V180.727C289.114 181.058 289.162 181.307 289.258 181.472C289.357 181.635 289.483 181.744 289.636 181.8C289.792 181.853 289.956 181.88 290.128 181.88C290.257 181.88 290.363 181.873 290.446 181.86C290.529 181.844 290.595 181.83 290.645 181.82L290.884 182.874C290.804 182.904 290.693 182.934 290.551 182.964C290.408 182.997 290.227 183.013 290.009 183.013C289.677 183.013 289.352 182.942 289.034 182.8C288.719 182.657 288.458 182.44 288.249 182.148C288.043 181.857 287.941 181.489 287.941 181.045V173.448ZM293.847 178.32V182.914H292.673V172.732H293.847V176.471H293.946C294.125 176.076 294.394 175.763 294.752 175.531C295.113 175.296 295.593 175.178 296.193 175.178C296.714 175.178 297.169 175.283 297.561 175.491C297.952 175.697 298.255 176.013 298.47 176.441C298.689 176.865 298.798 177.406 298.798 178.062V182.914H297.625V178.141C297.625 177.535 297.468 177.066 297.153 176.734C296.841 176.4 296.409 176.232 295.855 176.232C295.471 176.232 295.126 176.313 294.821 176.476C294.52 176.638 294.281 176.875 294.105 177.187C293.933 177.498 293.847 177.876 293.847 178.32ZM304.147 183.073C303.411 183.073 302.776 182.911 302.243 182.586C301.712 182.258 301.303 181.8 301.015 181.214C300.73 180.624 300.587 179.938 300.587 179.156C300.587 178.373 300.73 177.684 301.015 177.087C301.303 176.487 301.704 176.02 302.218 175.685C302.735 175.347 303.338 175.178 304.027 175.178C304.425 175.178 304.818 175.245 305.206 175.377C305.593 175.51 305.946 175.725 306.265 176.023C306.583 176.318 306.836 176.71 307.025 177.197C307.214 177.684 307.309 178.284 307.309 178.996V179.494H301.422V178.479H306.115C306.115 178.049 306.029 177.664 305.857 177.326C305.688 176.988 305.446 176.721 305.131 176.526C304.819 176.33 304.452 176.232 304.027 176.232C303.56 176.232 303.156 176.348 302.814 176.58C302.476 176.809 302.216 177.107 302.034 177.475C301.851 177.843 301.76 178.237 301.76 178.658V179.335C301.76 179.911 301.86 180.4 302.059 180.801C302.261 181.199 302.541 181.502 302.899 181.711C303.257 181.916 303.673 182.019 304.147 182.019C304.455 182.019 304.733 181.976 304.982 181.89C305.234 181.8 305.451 181.668 305.633 181.492C305.815 181.313 305.956 181.091 306.056 180.826L307.189 181.144C307.07 181.529 306.869 181.867 306.588 182.158C306.306 182.447 305.958 182.672 305.544 182.835C305.129 182.994 304.664 183.073 304.147 183.073ZM315.914 183.073C315.278 183.073 314.716 182.912 314.229 182.591C313.742 182.266 313.361 181.809 313.086 181.219C312.81 180.625 312.673 179.924 312.673 179.116C312.673 178.314 312.81 177.618 313.086 177.028C313.361 176.438 313.743 175.982 314.234 175.661C314.725 175.339 315.291 175.178 315.934 175.178C316.431 175.178 316.824 175.261 317.113 175.427C317.404 175.589 317.626 175.775 317.779 175.984C317.935 176.189 318.056 176.358 318.142 176.491H318.241V172.732H319.414V182.914H318.281V181.741H318.142C318.056 181.88 317.933 182.056 317.774 182.268C317.615 182.477 317.388 182.664 317.093 182.83C316.798 182.992 316.405 183.073 315.914 183.073ZM316.074 182.019C316.544 182.019 316.942 181.897 317.267 181.651C317.592 181.403 317.838 181.06 318.007 180.622C318.176 180.181 318.261 179.673 318.261 179.096C318.261 178.526 318.178 178.027 318.012 177.599C317.847 177.169 317.601 176.834 317.277 176.595C316.952 176.353 316.551 176.232 316.074 176.232C315.576 176.232 315.162 176.36 314.831 176.615C314.502 176.867 314.256 177.21 314.09 177.644C313.927 178.075 313.846 178.559 313.846 179.096C313.846 179.639 313.929 180.133 314.095 180.577C314.264 181.018 314.512 181.37 314.841 181.631C315.172 181.89 315.583 182.019 316.074 182.019ZM323.973 183.093C323.489 183.093 323.05 183.002 322.656 182.82C322.261 182.634 321.948 182.367 321.716 182.019C321.484 181.668 321.368 181.244 321.368 180.746C321.368 180.309 321.454 179.954 321.627 179.683C321.799 179.407 322.029 179.192 322.318 179.036C322.606 178.88 322.924 178.764 323.272 178.688C323.624 178.609 323.977 178.546 324.331 178.499C324.795 178.44 325.172 178.395 325.46 178.365C325.752 178.332 325.964 178.277 326.096 178.201C326.232 178.125 326.3 177.992 326.3 177.803V177.763C326.3 177.273 326.166 176.892 325.897 176.62C325.632 176.348 325.23 176.212 324.689 176.212C324.129 176.212 323.69 176.335 323.372 176.58C323.054 176.826 322.83 177.087 322.701 177.366L321.587 176.968C321.786 176.504 322.051 176.143 322.382 175.884C322.717 175.622 323.082 175.44 323.476 175.337C323.874 175.231 324.265 175.178 324.65 175.178C324.895 175.178 325.176 175.208 325.495 175.268C325.816 175.324 326.126 175.442 326.424 175.621C326.726 175.8 326.976 176.07 327.175 176.431C327.374 176.792 327.473 177.276 327.473 177.883V182.914H326.3V181.88H326.24C326.161 182.046 326.028 182.223 325.843 182.412C325.657 182.601 325.41 182.762 325.102 182.894C324.794 183.027 324.417 183.093 323.973 183.093ZM324.152 182.039C324.616 182.039 325.007 181.948 325.326 181.766C325.647 181.583 325.889 181.348 326.051 181.06C326.217 180.771 326.3 180.468 326.3 180.15V179.076C326.25 179.136 326.141 179.19 325.972 179.24C325.806 179.286 325.614 179.328 325.395 179.364C325.18 179.397 324.969 179.427 324.764 179.454C324.562 179.477 324.398 179.497 324.272 179.513C323.967 179.553 323.682 179.618 323.417 179.707C323.155 179.794 322.943 179.924 322.78 180.1C322.621 180.272 322.542 180.508 322.542 180.806C322.542 181.214 322.692 181.522 322.994 181.731C323.299 181.936 323.685 182.039 324.152 182.039ZM332.936 175.278V176.272H328.979V175.278H332.936ZM330.132 173.448H331.305V180.727C331.305 181.058 331.353 181.307 331.449 181.472C331.549 181.635 331.675 181.744 331.827 181.8C331.983 181.853 332.147 181.88 332.319 181.88C332.449 181.88 332.555 181.873 332.638 181.86C332.72 181.844 332.787 181.83 332.836 181.82L333.075 182.874C332.996 182.904 332.885 182.934 332.742 182.964C332.599 182.997 332.419 183.013 332.2 183.013C331.869 183.013 331.544 182.942 331.226 182.8C330.911 182.657 330.649 182.44 330.44 182.148C330.235 181.857 330.132 181.489 330.132 181.045V173.448ZM336.948 183.093C336.464 183.093 336.025 183.002 335.631 182.82C335.236 182.634 334.923 182.367 334.691 182.019C334.459 181.668 334.343 181.244 334.343 180.746C334.343 180.309 334.429 179.954 334.601 179.683C334.774 179.407 335.004 179.192 335.292 179.036C335.581 178.88 335.899 178.764 336.247 178.688C336.598 178.609 336.951 178.546 337.306 178.499C337.77 178.44 338.146 178.395 338.434 178.365C338.726 178.332 338.938 178.277 339.071 178.201C339.207 178.125 339.275 177.992 339.275 177.803V177.763C339.275 177.273 339.14 176.892 338.872 176.62C338.607 176.348 338.204 176.212 337.664 176.212C337.104 176.212 336.665 176.335 336.346 176.58C336.028 176.826 335.805 177.087 335.675 177.366L334.562 176.968C334.76 176.504 335.026 176.143 335.357 175.884C335.692 175.622 336.056 175.44 336.451 175.337C336.849 175.231 337.24 175.178 337.624 175.178C337.869 175.178 338.151 175.208 338.469 175.268C338.791 175.324 339.101 175.442 339.399 175.621C339.701 175.8 339.951 176.07 340.15 176.431C340.349 176.792 340.448 177.276 340.448 177.883V182.914H339.275V181.88H339.215C339.135 182.046 339.003 182.223 338.817 182.412C338.632 182.601 338.385 182.762 338.077 182.894C337.768 183.027 337.392 183.093 336.948 183.093ZM337.127 182.039C337.591 182.039 337.982 181.948 338.3 181.766C338.622 181.583 338.864 181.348 339.026 181.06C339.192 180.771 339.275 180.468 339.275 180.15V179.076C339.225 179.136 339.116 179.19 338.947 179.24C338.781 179.286 338.589 179.328 338.37 179.364C338.154 179.397 337.944 179.427 337.738 179.454C337.536 179.477 337.372 179.497 337.246 179.513C336.941 179.553 336.656 179.618 336.391 179.707C336.129 179.794 335.917 179.924 335.755 180.1C335.596 180.272 335.516 180.508 335.516 180.806C335.516 181.214 335.667 181.522 335.969 181.731C336.273 181.936 336.66 182.039 337.127 182.039Z" fill="#A5A5A5"/>
                    </svg>
                    `,
            confirmButtonText: "OK",
          });
          return; // Hentikan proses jika validasi gagal
        }
        const url = this.registrationType === "New ID" ? "/api/distribution/qr-registration/new-id/comparison" : "/api/distribution/qr-registration/existing-id/comparison";

        const formatRange = (range) => {
          const [startMonth, startYear] = range.split(" to ")[0].split(" ");
          const [endMonth, endYear] = range.split(" to ")[1].split(" ");

          return `${startMonth}-${endMonth} ${startYear}`;
        };

        const first_range = formatRange(this.firstRange);
        const second_range = formatRange(this.secondRange);

        let params = { first_range, second_range };

        if (this.selectedYear && this.selectedYear !== "null") {
          params.manufacture_year = this.selectedYear;
        }
        if (this.selectedComparisonRegion) {
          params.region = this.selectedComparisonRegion.loc_code;
        }

        const res = await axios.get(url, { params });

        console.log("API Response:", res.data); // Debugging log

        if (!res.data || typeof res.data.data !== "object") {
          throw new Error("Invalid response format: Expected an object in res.data.data");
        }

        const responseData = res.data.data;
        const firstYear = first_range.match(/\d{4}/g)?.[0]; // Extract first year (e.g., 2023)
        const secondYear = second_range.match(/\d{4}/g)?.[0]; // Extract second year (e.g., 2024)

        let flattenedData = [];

        // Extracting data and assigning years correctly
        Object.keys(responseData).forEach((month) => {
          responseData[month].forEach((item, index) => {
            flattenedData.push({
              month: month,
              year_group: index === 0 ? firstYear : secondYear, // First entry belongs to first year, second to second year
              value: item.value || 0,
            });
          });
        });

        if (flattenedData.length === 0) {
          throw new Error("No data available for the selected range.");
        }

        // Prepare data for Excel
        const header = ["Month", "Year", "Value"];
        const rows = flattenedData.map((item) => [item.month, item.year_group, item.value]);

        const wb = XLSX.utils.book_new();
        const wsData = [header, ...rows];
        const ws = XLSX.utils.aoa_to_sheet(wsData);

        XLSX.utils.book_append_sheet(wb, ws, "Overall Data");

        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

        function s2ab(s) {
          const buf = new ArrayBuffer(s.length);
          const view = new Uint8Array(buf);
          for (let i = 0; i < s.length; i++) {
            view[i] = s.charCodeAt(i) & 0xff;
          }
          return buf;
        }

        const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
        const link = document.createElement("a");
        const xlsxUrl = URL.createObjectURL(blob);
        link.href = xlsxUrl;
        link.download = `${this.registrationType} perfomance_comparison_.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error fetching replacement data:", error);
        alert("Error: " + error.message);
      }
    },

    async downloadExcelChartStacked() {
      try {
        let selectedYear = this.selectedYearGlobal; // Use global year
        const currentYear = new Date().getFullYear(); // Get the current year

        // If no year is selected on initialization, use "All Years" by default
        if (!selectedYear) {
          selectedYear = "All Years";
        }

        const params = {};

        if (this.dateRange.start) {
          params.start = this.dateRange.start;
        }
        if (this.dateRange.end) {
          params.end = this.dateRange.end;
        }
        // Add params based on toggle status
        if (this.showPerformanceYear) {
          params.show_performance_year = true;
        } else {
          if (selectedYear !== "All Years") {
            params.manufacture_year = selectedYear;
          }
        }
        // Handle selectedChartStacked (use loc_code for selected dealer)
        let isDealerSelected = false;
        if (this.selectedChartStacked && this.selectedChartStacked.loc_code) {
          params.dealer = this.selectedChartStacked.loc_code; // Use the loc_code from selectedChartStacked
          isDealerSelected = true;
        }

        // Define the URL based on the registration type (New ID / Existing ID)
        const url = this.registrationType === "New ID" ? "/api/distribution/qr-registration/new-id" : "/api/distribution/qr-registration/existing-id";

        // Fetch data from the API
        const res = await axios.get(url, { params });

        if (res.data && res.data.data) {
          const data = res.data.data;
          const rows = [];

          if (this.showPerformanceYear) {
            // Jika toggle aktif, data dikelompokkan berdasarkan bulan dan tahun
            const headers = ["Month"];
            const years = new Set();
            const monthDataMap = {};

            // Iterasi data dan simpan dalam format yang sesuai
            data.forEach((item) => { // Gunakan `data` dari respons API,
              const { tahun, bulan, value } = item;
              years.add(tahun);

              // Jika bulan belum ada dalam objek, buat array baru
              if (!monthDataMap[bulan]) {
                monthDataMap[bulan] = {};
              }
              // Simpan nilai berdasarkan tahun
              monthDataMap[bulan][tahun] = value || null;
            });

            // Urutkan tahun dari terbaru ke terlama
            const sortedYears = Array.from(years).sort((a, b) => b - a);
            headers.push(...sortedYears); // Tambahkan tahun ke header
            rows.push(headers); // Tambahkan header ke dalam daftar data

            // Iterasi setiap bulan dan susun datanya
            Object.keys(monthDataMap).forEach((bulan) => {
              const row = [bulan]; // Awali dengan nama bulan
              sortedYears.forEach((tahun) => {
                row.push(monthDataMap[bulan][tahun] || 0); // Isi data, jika tidak ada set 0
              });
              rows.push(row); // Tambahkan baris ke hasil akhir
            });

            console.log("Hasil rows untuk Excel:", rows); // Cek apakah datanya benar sebelum export
          } else {
            // Handle the case when toggle is not active
            if (isDealerSelected) {
              // Handle the response when dealer is selected
              const headers = ["Month"];
              const yearGroupsSet = new Set();

              // Collect all unique year groups present in the data
              Object.keys(data).forEach((month) => {
                data[month].forEach((item) => {
                  yearGroupsSet.add(item.year_group);
                });
              });

              // Convert Set to Array and sort it (place "Older" last)
              const yearGroups = Array.from(yearGroupsSet).sort((a, b) => {
                if (a === "Older") return 1;
                if (b === "Older") return -1;
                return b - a;
              });

              headers.push(...yearGroups); // Add year groups to headers
              rows.push(headers); // Add headers to rows

              // Iterate over each month and fill in the data
              Object.keys(data).forEach((month) => {
                const cleanedMonth = month.replace(/\s?\d{4}/, "").trim(); // Remove the year (e.g., "2024") from the month
                const row = [cleanedMonth]; // Add the cleaned month as the first column

                // Initialize row data for each year group to 0
                const rowData = {};
                yearGroups.forEach((group) => {
                  rowData[group] = 0; // Default to 0
                });

                // Fill in the actual data for the month
                data[month].forEach((item) => {
                  rowData[item.year_group] = item.value || 0; // Set the value for the year group
                });

                // Add the row data for each year group to the row
                yearGroups.forEach((group) => {
                  row.push(rowData[group]);
                });

                rows.push(row); // Add the row to the output
              });
            } else {
              // Handle the case where a specific year is selected (including "Older" for <=2021)
              if (selectedYear !== "All Years") {
                const headers = ["Month", selectedYear.toString()];
                rows.push(headers); // Add headers to rows

                // Build data rows for each month
                Object.keys(data).forEach((month) => {
                  const cleanedMonth = month.replace(/\s?\d{4}/, "").trim(); // Remove the year (e.g., "2024") from the month
                  const row = [cleanedMonth]; // Add the cleaned month as the first column
                  const monthData = data[month];

                  // Initialize year group data
                  const rowData = { [selectedYear]: 0 };

                  // Map the data for the corresponding year
                  monthData.forEach((item) => {
                    const yearGroup = item.year_group.toString(); // Ensure year_group is compared as string
                    const value = item.value || 0; // Default to 0 if value is undefined

                    // Map "Older" data to <=2021 (or selectedYear)
                    if (yearGroup === "Older" && selectedYear === `<=${currentYear - 3}`) {
                      rowData[selectedYear] = value; // Set value from "Older" group
                    } else if (yearGroup === selectedYear.toString()) {
                      rowData[selectedYear] = value;
                    }
                  });

                  // Push the row with data for the selected year
                  rows.push([cleanedMonth, rowData[selectedYear]]);
                });
              } else {
                // Handle the "All Years" case (no dealer selected)
                const headers = [
                  "Month",
                  currentYear.toString(), // Current year
                  (currentYear - 1).toString(), // Current year - 1
                  (currentYear - 2).toString(), // Current year - 2
                  `<=${currentYear - 3}`, // Older data (current year - 3 or earlier)
                  "Unknown",
                ];

                rows.push(headers); // Add headers to rows

                // Build data rows for each month
                Object.keys(data).forEach((month) => {
                  const cleanedMonth = month.replace(/\s?\d{4}/, "").trim(); // Remove the year from the month
                  const row = [cleanedMonth]; // Add the cleaned month as the first column
                  const monthData = data[month];

                  // Initialize year group data
                  const rowData = {
                    [currentYear]: 0,
                    [currentYear - 1]: 0,
                    [currentYear - 2]: 0,
                    [`<=${currentYear - 3}`]: 0,
                    [`Unknown`]: 0,
                  };

                  // Map the data for the corresponding years
                  monthData.forEach((item) => {
                    const yearGroup = item.year_group.toString(); // Ensure year_group is compared as string
                    const value = item.value || 0; // Default to 0 if value is undefined

                    if (yearGroup === currentYear.toString()) rowData[currentYear] = value;
                    if (yearGroup === (currentYear - 1).toString()) rowData[currentYear - 1] = value;
                    if (yearGroup === (currentYear - 2).toString()) rowData[currentYear - 2] = value;
                    if (yearGroup === "Older") rowData[`<=${currentYear - 3}`] = value;
                    if (yearGroup === "Unknown") rowData[`Unknown`] = value;
                  });

                  // Push the row with data for each year
                  rows.push([cleanedMonth, rowData[currentYear], rowData[currentYear - 1], rowData[currentYear - 2], rowData[`<=${currentYear - 3}`], rowData[`Unknown`]]);
                });
              }
            }
          }

          // Create Excel workbook and worksheet
          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.aoa_to_sheet(rows); // Convert rows to Excel worksheet

          XLSX.utils.book_append_sheet(wb, ws, `${this.registrationType} - Stacked Column`);

          // Export the workbook to an Excel file
          const xlsxOutput = XLSX.write(wb, { bookType: "xlsx", type: "array" });
          const blob = new Blob([xlsxOutput], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          // Create download link and trigger download
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = this.showPerformanceYear
            ? `${this.registrationType} - Stacked Colum Performance Year.xlsx`
            : `${this.registrationType} - Stacked Column Chart.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.warn("No data found for Excel export.");
        }
      } catch (error) {
        console.error("Error downloading stacked chart data:", error);
      }
    },
    async downloadExcelOverallProductionYear() {
      try {
        const selectedYear = this.selectedYearGlobal; // Use global year
        const params = {};

        // Add params only if user selected a year
        // if (selectedYear && selectedYear !== "All Years") {
        //   params.manufacture_year = selectedYear;
        // }
        if (this.dateRange.start) {
          params.start = this.dateRange.start;
        }
        if (this.dateRange.end) {
          params.end = this.dateRange.end;
        }
        // Add params based on toggle status
        if (this.showPerformanceYear) {
          params.show_performance_year = true;
        } else {
          if (selectedYear !== "All Years") {
            params.manufacture_year = selectedYear;
          }
        }
        // Define the URL based on the registration type (New ID / Existing ID)
        const url = this.registrationType === "New ID" ? "/api/distribution/qr-registration/new-id-by-production-year" : "/api/distribution/qr-registration/existing-id-by-production-year";

        // Fetch data from the API
        const res = await axios.get(url, { params });

        if (res.data && res.data.data) {
          const data = res.data.data;
          const rows = [];

          // Build headers (e.g., Year, Value)
          const headers = ["Year", "Value"];
          rows.push(headers); // Add headers to rows

          // Build data rows
          data.forEach((item) => {
            const row = [item.year_group, item.value || 0];
            rows.push(row); // Add row to rows
          });

          // Create Excel workbook and worksheet
          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.aoa_to_sheet(rows); // Convert rows to Excel worksheet

          XLSX.utils.book_append_sheet(wb, ws, `${this.registrationType === "Existing ID" ? "Ex ID" : this.registrationType} - Overall Production`);

          // Export the workbook to an Excel file
          const xlsxOutput = XLSX.write(wb, { bookType: "xlsx", type: "array" });
          const blob = new Blob([xlsxOutput], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = this.showPerformanceYear
            ? `${this.registrationType} - Overall Production Year Performance Year.xlsx`
            : `${this.registrationType} - Overall Production Year Column Chart.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          // console.warn("No data found for Excel export.");
        }
      } catch (error) {
        // console.error("Error downloading overall production data:", error);
      }
    },
    async downloadExcelSegment() {
      try {
        // Use a local variable to handle the selected year logic
        let yearToUse = this.selectedYearSegment || this.selectedYearGlobal;

        // If no year is selected, use "All Years" as the default
        if (!yearToUse) {
          yearToUse = "All Years"; // Use a local variable instead of directly assigning to selectedYear
        }

        const params = {};

        // Add params only if the user selected a year
        if (yearToUse && yearToUse !== "All Years") {
          params.manufacture_year = yearToUse;
        }
        if (this.dateRange.start) {
          params.start = this.dateRange.start;
        }
        if (this.dateRange.end) {
          params.end = this.dateRange.end;
        }

        // Handle when segments are selected
        let isSegmentSelected = false;
        if (this.selectedSegment && this.selectedSegment.length > 0) {
          params.segment = this.selectedSegment.join(","); // Use the selected segments
          isSegmentSelected = true;
        }

        // Define the URL based on the registration type (New ID / Existing ID)
        const url = this.registrationType === "New ID" ? "/api/distribution/qr-registration/new-id-by-segment" : "/api/distribution/qr-registration/existing-id-by-segment";

        // Fetch data from the API
        const res = await axios.get(url, { params });

        if (res.data && res.data.data) {
          const data = res.data.data;
          const rows = [];

          // Define headers based on segment selection
          const headers = ["Month"];
          if (isSegmentSelected) {
            // If segments are selected, create a header for each segment
            this.selectedSegment.forEach((segment) => {
              headers.push(`${segment} (${yearToUse})`);
            });
          } else {
            // Default to "All Segment" if no specific segment is selected
            headers.push(`${yearToUse} (All Segment)`);
          }
          rows.push(headers); // Add headers to the rows

          // Iterate over each month and populate the data by grabbing the value directly
          Object.keys(data).forEach((month) => {
            // Clean the month label by removing the year part
            const cleanedMonth = month.replace(/\s*\d{4}/, "").trim(); // Clean up the month label
            const row = [cleanedMonth]; // Start with the cleaned month name

            const monthData = data[month];

            if (isSegmentSelected) {
              // If segments are selected, add the values for each segment
              this.selectedSegment.forEach((segment) => {
                // Grab the value directly for the selected segment, default to 0 if not found
                const segmentData = monthData.find((item) => item.segment === segment);
                row.push(segmentData ? segmentData.value : 0);
              });
            } else {
              // Default case: handle "All Segment" data
              const segmentData = monthData.find((item) => item.segment === "All Segment");
              // Grab the value directly for "All Segment", default to 0 if not found
              row.push(segmentData ? segmentData.value : 0);
            }

            rows.push(row); // Add the row to the output
          });

          // Create Excel workbook and worksheet
          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.aoa_to_sheet(rows); // Convert rows to Excel worksheet

          XLSX.utils.book_append_sheet(wb, ws, `${this.registrationType === "Existing ID" ? "Ex ID" : this.registrationType} - Segment`);

          // Export the workbook to an Excel file
          const xlsxOutput = XLSX.write(wb, { bookType: "xlsx", type: "array" });
          const blob = new Blob([xlsxOutput], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          // Create download link and trigger download
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${this.registrationType} - Segment Line Chart.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          // console.warn("No data found for Excel export.");
        }
      } catch (error) {
        // console.error("Error downloading segment chart data:", error);
      }
    },
    async downloadExcelRegion() {
      try {
        const selectedYear = this.selectedYearRegion || this.selectedYearGlobal; // Use section-specific year if available, otherwise global year

        const params = {};
        // Add params only if user selected a year
        if (selectedYear && selectedYear !== "All Years") {
          params.manufacture_year = selectedYear;
        }
        if (this.dateRange.start) {
          params.start = this.dateRange.start;
        }
        if (this.dateRange.end) {
          params.end = this.dateRange.end;
        }
        if (this.selectedRegion) {
          params.region = this.selectedRegion.split(" - ")[0];
        }

        const url = this.registrationType === "New ID" ? "/api/distribution/qr-registration/new-id-by-region" : "/api/distribution/qr-registration/existing-id-by-region";

        const res = await axios.get(url, { params });

        if (res.data && res.data.data) {
          const data = res.data.data;
          const rows = [];

          // Build headers
          let headers = ["Region Name"];
          const firstRegion = Object.values(data)[0];
          if (firstRegion) {
            headers = headers.concat(firstRegion.map((item) => item.bulan));
          }
          rows.push(headers); // Add headers to rows

          // Build data rows
          for (const [region, values] of Object.entries(data)) {
            const row = [region];

            // Assuming the API returns data for the selected year directly
            const monthlyData = values.map((v) => v.value || 0); // Use the value directly from the API response

            rows.push(row.concat(monthlyData)); // Add the region data row to Excel rows
          }

          // Create Excel workbook and worksheet
          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.aoa_to_sheet(rows); // Convert rows to Excel worksheet

          XLSX.utils.book_append_sheet(wb, ws, `${this.registrationType === "Existing ID" ? "Ex ID" : this.registrationType} - Region`);

          // Export the workbook to an Excel file
          const xlsxOutput = XLSX.write(wb, { bookType: "xlsx", type: "array" });
          const blob = new Blob([xlsxOutput], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${this.registrationType} - Region.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          // console.warn("No data found for Excel export.");
        }
      } catch (error) {
        // console.error("Error downloading region data:", error);
      }
    },
    async downloadExcelDealer() {
      try {
        const selectedYear = this.selectedYearDealer || this.selectedYearGlobal;
        const selectedYearString = selectedYear ? selectedYear.toString() : ""; // Ensure it’s a string

        const currentYear = new Date().getFullYear();
        const cutoffYear = currentYear - 3;

        const params = {};

        // Add params based on toggle status
        if (this.showPerformanceYear) {
          params.show_performance_year = true; // Tambahkan parameter ini
          // Add params only if a specific year is selected and it’s not <=cutoffYear
          if (selectedYearString && selectedYearString !== "All Years" && !selectedYearString.startsWith("<=")) {
            params.manufacture_year = selectedYearString;
          }
        } else {
          // Add params only if a specific year is selected and it’s not <=cutoffYear
          if (selectedYearString && selectedYearString !== "All Years" && !selectedYearString.startsWith("<=")) {
            params.manufacture_year = selectedYearString;
          }
        }

        if (this.dateRange.start) params.start = this.dateRange.start;
        if (this.dateRange.end) params.end = this.dateRange.end;
        if (this.selectedDealer) {
          const dealerCode = this.selectedDealer.split(" - ")[0];
          const dealerParts = dealerCode.split("/");
          params.dealer = dealerParts[0];
        };

        const url = this.registrationType === "New ID"
          ? "/api/distribution/qr-registration/new-id-by-dealer"
          : "/api/distribution/qr-registration/existing-id-by-dealer";

        const res = await axios.get(url, { params });

        if (res.data && res.data.data && Object.keys(res.data.data).length > 0) {
          const data = res.data.data;
          const rows = [];

          let headers = ["Dealer Name"];

          // Headers
          if (this.showPerformanceYear) {
            // Jika toggle aktif, header adalah tahun-tahun yang ada di data
            const years = new Set();
            Object.values(data).forEach((values) => {
              values.forEach((v) => {
                years.add(v.year_group);
              });
            });
            headers.push(...Array.from(years).sort((a, b) => b - a)); // Urutkan tahun dari terbaru ke terlama
          } else if (selectedYearString === "All Years" || selectedYearString === "") {
            // Jika toggle tidak aktif dan tahun adalah "All Years"
            headers.push(currentYear.toString(), (currentYear - 1).toString(), (currentYear - 2).toString(), `<=${cutoffYear}`, "Unknown".toString());
          } else {
            // Jika toggle tidak aktif dan tahun tertentu dipilih
            headers.push(selectedYearString);
          }
          rows.push(headers);

          // Content
          for (const [dealer, values] of Object.entries(data)) {
            const row = [dealer];

            if (this.showPerformanceYear) {
              // Jika toggle aktif, isi data berdasarkan tahun yang ada di headers
              const yearDataMap = {};
              values.forEach((v) => {
                yearDataMap[v.year_group] = v.value || 0;
              });

              headers.slice(1).forEach((year) => {
                row.push(yearDataMap[year] || 0);
              });
            } else if (selectedYearString === "All Years" || selectedYearString === "") {
              // Jika toggle tidak aktif dan tahun adalah "All Years"
              const yearGroups = {
                [currentYear]: 0,
                [currentYear - 1]: 0,
                [currentYear - 2]: 0,
                [`<=${cutoffYear}`]: 0,
                [`Unknown`]: 0,
              };

              values.forEach((v) => {
                const year = v.year_group === "Older" ? `<=${cutoffYear}` : v.year_group;
                yearGroups[year] = v.value || 0;
              });

              // Data dikirim sebagai number
              row.push(
                Number(yearGroups[currentYear]),
                Number(yearGroups[currentYear - 1]),
                Number(yearGroups[currentYear - 2]),
                Number(yearGroups[`<=${cutoffYear}`]),
                Number(yearGroups["Unknown"])
              );
            } else {
              // Jika toggle tidak aktif dan tahun tertentu dipilih
              const yearKey = selectedYearString.startsWith("<=") ? "Older" : selectedYearString;
              const yearData = values.find((v) => v.year_group === yearKey);

              row.push(yearData ? yearData.value : 0);
            }

            rows.push(row);
          }

          // Create Excel workbook and worksheet
          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.aoa_to_sheet(rows);

          XLSX.utils.book_append_sheet(wb, ws, `${this.registrationType === "Existing ID" ? "Ex ID" : this.registrationType} - Dealer`);

          // Export the workbook to an Excel file
          const xlsxOutput = XLSX.write(wb, { bookType: "xlsx", type: "array" });
          const blob = new Blob([xlsxOutput], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // Create download link and trigger download
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = this.showPerformanceYear
            ? `${this.registrationType} - Dealer Performance Year.xlsx`
            : `${this.registrationType} - Dealer.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.warn("No data found for Excel export.");
        }
      } catch (error) {
        console.error("Error downloading dealer data:", error);
      }
    },
  },
};
</script>

<style>
.loading {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border: none;
}

.new-id-production-year {
  min-height: 625px;
}

.card-table {
  min-height: 300px;
}

.card-title {
  font-size: 1.1rem;
  font-weight: 600;
}

.form-select,
.btn {
  font-size: 0.875rem;
}

.bi-download {
  margin-left: 0.25rem;
}

.action-header {
  width: 1%;
  /* This forces the column to be as narrow as possible */
  white-space: nowrap;
  color: #4b4b4b;
  background-color: #ffffff;
  text-align: left;
}

.action-body {
  width: 1%;
  /* This forces the column to be as narrow as possible */
  white-space: nowrap;
  color: #4b4b4b;
  background-color: #ffffff;
  border-top: none;
  border-bottom: none;
  text-align: left;
}

.action-buttons {
  display: flex;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;
  border-radius: 50px;
}

.hso-download-button {
  margin-top: 12px;
  height: 40px;
  margin-top: 0px;
  color: #2f2f2f;
  background-color: #ffffff;
  box-shadow: none;
  width: 100%;
  white-space: nowrap;
}

.hso-table-header {
  color: #4b4b4b;
  background-color: #ffffff;
  text-align: left;
}

.hso-table-body {
  border-bottom: none;
  border-top: none;
  text-align: left;
}

.hso-table-pagination {
  color: #cbcbcb;
}

.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip {
  visibility: hidden;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 200px;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.tooltip-title {
  font-weight: bold;
  margin-bottom: 5px;
}

.tooltip-content {
  font-size: 0.9em;
  color: #666;
}

.filter-date {
  position: relative;
}

.filter-date.icon {
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}

.filter-date.icon.fa-calendar::before {
  content: "\f133";
  box-sizing: border-box;
  font-family: "Font Awesome 6 Free";
  position: absolute;
  right: 0;
  top: 0;
  width: 32px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flatpickr-months {
  background-color: #3c97fe !important;
  color: white !important;
}

.flatpickr-months .flatpickr-month {
  color: white !important;
}

.flatpickr-monthDropdown-months {
  background-color: #3c97fe !important;
  color: white !important;
}

.flatpickr-monthDropdown-months option {
  background-color: white !important;
  color: black !important;
}

.flatpickr-current-month input.cur-year {
  background-color: #3c97fe !important;
  color: white !important;
  border: none;
}

.flatpickr-prev-month,
.flatpickr-next-month {
  fill: white !important;
}

.flatpickr-weekdays {
  background-color: #3c97fe !important;
}

.flatpickr-weekday {
  color: white !important;
  font-weight: bold;
}
</style>
